import './constants/travel.css';
import { useParams } from 'react-router-dom';
import {
  useApproveTravelRequestMutation,
  useGetTravelRequestByIdQuery,
  useLazyPrintTravelRequestQuery,
} from '../../store';
import { CardWizard } from '../../layouts';
import { useEffect, useMemo, useRef, useState } from 'react';
import {
  ApproveActionMessage,
  RejectActionMessage,
  HoldActionMessage,
  CommonTable,
  ConfirmationDialog,
  TextInput,
  SelectInput,
} from '../../components';
import { HeadingWizard } from '../../components';
import { Controller, useForm } from 'react-hook-form';
import {
  IModeOfJourneyForm,
  IPerKmClaimForm,
  IPerDiemClaimForm,
  IExpenseClaimForm,
  IAccomodationForm,
  IApprovalForm,
} from './constants/travelreq.interface';
import {
  ExpenseCategory,
  SubmissionStatus,
  SystemApprovalAction,
} from '../../enums';
import {
  convertDateToDayJs,
  downloadFileFromBlob,
  extractErrorMessageFromAPI,
  formatDayJsDate,
  formatNumber,
  getFormattedAmount,
  formatClaimMonthYear,
  mapToDropdownOptions,
} from '../../utils';
import { useAuth, useNotification } from '../../contexts';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { useNavigate } from 'react-router-dom';
import {
  APPROVAL_STATUS_LABEL_MAP,
  CREATOR_LEVEL,
  DEFAULT_FORM_FIELD_CONFIG,
  TRAVEL_REQUEST_LINE_ITEM_SECTION_LABEL_MAP,
} from './constants/travelreq.constants';
import { IApprovalModalConfig, ITravelAttachment } from '../../types';
import {
  Dropdown,
  MenuProps,
  message,
  Modal,
  Popover,
  Select,
  Skeleton,
  Switch,
  Tooltip,
  Upload,
  Tag,
  Checkbox,
  Button,
  Alert,
} from 'antd';
import { InfoCircleOutlined, UploadOutlined } from '@ant-design/icons';
import { ReloadOutlined, SwapOutlined } from '@ant-design/icons';
import { ApprovalConfirmationModal } from '../Pricing/components/ApprovalConfirmationModal';
import {
  useLazyGetFormFieldMappingQuery,
  useGetAllUsersQuery,
} from '../../store';
import { useReactTable } from '@tanstack/react-table';
import { getCoreRowModel } from '@tanstack/react-table';
import LineItemTable from '../../components/common/components/LineItemTable';
import { ButtonWizard } from '../../components';
import { AnimatePresence } from 'framer-motion';
import { SideSheetHeader, SideSheet } from '../../layouts';
import {
  ArrowDown,
  BadgeCheck,
  Eye,
  EyeIcon,
  Mail,
  PenSquareIcon,
  Logs,
  User,
  UsersIcon,
  X,
  SendIcon,
  Network,
  Printer,
  FileCheck2,
  FileX2,
  CheckCircleIcon,
  XIcon,
  DownloadIcon,
  ChevronRight,
  Server,
  Paperclip,
  Filter,
  ArrowUpDown,
} from 'lucide-react';
import AttachmentTable from '../../components/common/components/AttachmentsTable';
import LineItemAttachmentCarousel from '../../components/common/components/LineItemAttachmentCarousel';

import { HandRaisedIcon } from '@heroicons/react/24/solid';
import { UserGroupIcon } from '@heroicons/react/24/solid';
import { InReviewActionMessage } from '../../components/process/ApproveActionMessage';
import {
  ClaimRequestType,
  ReviewType,
  TourRequestType,
  TravelRequestLineItemSection,
  TravelRequestMarkAsPaidStatus,
} from './constants/travelreq.enum';
import {
  ClientCode,
  SystemApprovalStatus,
  SystemRoles,
} from '../../enums/common';
import {
  useGetTravelApprovalLogsByIdQuery,
  useGetTravelChangeLogsByIdQuery,
  useGetTravelSapLogsByIdQuery,
  useSendTravelRequestForClaimMutation,
  useCancelClaimRequestMutation,
  useLazyDownloadTravelAttachmentsZipQuery,
  useUpdateTravelRequestPaidStatusMutation,
  useResetApprovalHierarchyMutation,
  useRearrangeApprovalHierarchyMutation,
  useGetAttachmentRecoveryQuery,
} from '../../store/rtkQuery/travelReq';
import ModeOfJourneyLineItemDetails from '../../components/common/components/ModeOfJourneyLineItemDetails';
import AccommodationLineItemDetails from '../../components/common/components/AccommodationLineItemDetails';
import ExpenseClaimLineItemDetails from '../../components/common/components/ExpenseClaimLineItemDetails';
import PerDiemLineItemDetails from '../../components/common/components/PerDiemLineItemDetails';
import PerKmLineItemDetails from '../../components/common/components/PerKmLineItemDetails';
import {
  getClaimTypeFromCategories,
  mapTravelGalleryAttachments,
  mergeTravelGalleryAttachments,
  prioritizeTravelAttachmentColumn,
} from './travel.utils';
import {
  ArrowLeftIcon,
  CheckBadgeIcon,
  CheckIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  PaperClipIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import { useGetEmployeeByIdQuery } from '../../store/rtkQuery/userAccessControl';
import LineItemHeaderTitle from '../../components/common/components/LineItemHeaderTitle';
import {
  getLineItemAccordionTriggerProps,
  handleLineItemSortMenuClick,
  LineItemAccordionLineItemContent,
  LineItemAccordionToggleButton,
} from '../../components/common/components/LineItemAccordion';
import { getNameInitials } from '../../utils/nameUtils';
import { isAdminTypeRole, isTravelDesk } from '../../utils/userUtils';
import BottomMessageBox from '../../components/BottomMessageBox';
import { DndContext, closestCenter } from '@dnd-kit/core';
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
  arrayMove,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import ApprovalHierarchySideSheet, {
  ApprovalHierarchyFormValues,
} from './ApprovalHierarchySideSheet';
import Chat from '../ActivityTracking/Chat/Chat';
import { createPortal } from 'react-dom';

export const { Option } = Select;

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

export enum LogsSortByOptions {
  DESC = 'desc',
  ASC = 'asc',
}

// Helper function to render approval status badge
// Backend provides currentApprover and lastActionApprover based on approval status
const renderApprovalStatusBadge = (
  data: any,
  lastActionApprover: string | null,
) => {
  if (!data) return null;

  const approvalStatus = data.approvalStatus;
  const isClaimFinalApproved = data.isClaimFinalApproved;
  const isRequestSubmittedForClaimApproval =
    data.isRequestSubmittedForClaimApproval;
  const isRequestFinalApproved = data.isRequestFinalApproved;
  const currentApprover = data.currentApprover;
  // Backend will provide currentApprover and lastActionApprover based on approval status
  const currentApproverName = currentApprover?.FullName || '';
  // For rejected/hold/cancelled, use lastActionApprover (passed from backend or extracted from logs)
  // For pending/in_review, use currentApprover (from backend)

  // If final approved, show "Claim Approved"
  if (isClaimFinalApproved) {
    return (
      <Tag
        bordered={false}
        className="!px-3 !py-1.5 !text-xs !rounded-lg !shadow-sm flex items-center gap-x-2 bg-gradient-to-r from-green-500 to-green-600 text-white border border-green-400/30"
      >
        <CheckCircleIcon className="size-4 stroke-[2.5px] text-white" />
        <span className="font-semibold tracking-wide">Claim Approved</span>
      </Tag>
    );
  }

  // Handle different approval statuses
  switch (approvalStatus) {
    case SystemApprovalStatus.APPROVED:
      return (
        <Tag
          bordered={false}
          className="!px-3 !py-1.5 !text-xs !rounded-lg !shadow-sm flex items-center gap-x-2 bg-gradient-to-r from-green-500 to-green-600 text-white border border-green-400/30"
        >
          <CheckCircleIcon className="size-4 stroke-[2.5px] text-white" />
          <span className="font-semibold tracking-wide">Approved</span>
        </Tag>
      );

    case SystemApprovalStatus.PENDING:
      // Use currentApprover from backend for PENDING status
      return (
        <Tag
          bordered={false}
          className="!px-3 !py-1.5 !text-xs !rounded-lg !shadow-sm flex items-center gap-x-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white border border-blue-400/30"
        >
          <div className="relative flex items-center">
            <div className="absolute h-2 w-2 rounded-full bg-white animate-ping opacity-75"></div>
            <div className="relative h-2 w-2 rounded-full bg-white"></div>
          </div>
          <span className="font-semibold tracking-wide">
            Pending{currentApproverName ? ` with ${currentApproverName}` : ''}
          </span>
        </Tag>
      );

    case SystemApprovalStatus.IN_REVIEW:
      // Use currentApprover from backend for IN_REVIEW status
      return (
        <Tag
          bordered={false}
          className="!px-3 !py-1.5 !text-xs !rounded-lg !shadow-sm flex items-center gap-x-2 bg-gradient-to-r from-amber-500 to-amber-600 text-white border border-amber-400/30"
        >
          <div className="relative flex items-center">
            <div className="absolute h-2 w-2 rounded-full bg-white animate-ping opacity-75"></div>
            <div className="relative h-2 w-2 rounded-full bg-white"></div>
          </div>
          <span className="font-semibold tracking-wide">
            In Review{currentApproverName ? ` (${currentApproverName})` : ''}
          </span>
        </Tag>
      );

    case SystemApprovalStatus.REJECTED:
      // Use lastActionApprover from backend for REJECTED status
      return (
        <Tag
          bordered={false}
          className="!px-3 !py-1.5 !text-xs !rounded-lg !shadow-sm flex items-center gap-x-2 bg-gradient-to-r from-red-500 to-red-600 text-white border border-red-400/30"
        >
          <XIcon className="size-4 stroke-[2.5px] text-white" />
          <span className="font-semibold tracking-wide">
            Rejected by {lastActionApprover || currentApproverName || 'N/A'}
          </span>
        </Tag>
      );

    case SystemApprovalStatus.HOLD:
      // Use lastActionApprover from backend for HOLD status
      return (
        <Tag
          bordered={false}
          className="!px-3 !py-1.5 !text-xs !rounded-lg !shadow-sm flex items-center gap-x-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white border border-orange-400/30"
        >
          <HandRaisedIcon className="size-4 text-white" />
          <span className="font-semibold tracking-wide">
            Hold by {lastActionApprover || currentApproverName || 'N/A'}
          </span>
        </Tag>
      );

    case SystemApprovalStatus.CANCELLED:
      // Use cancelledByUser.FullName from backend when available; else lastActionApprover/currentApproverName
      const cancelledByName =
        data?.cancelledByUser?.FullName ||
        lastActionApprover ||
        currentApproverName ||
        'N/A';
      return (
        <Tag
          bordered={false}
          className="!px-3 !py-1.5 !text-xs !rounded-lg !shadow-sm flex items-center gap-x-2 bg-gradient-to-r from-gray-500 to-gray-600 text-white border border-gray-400/30"
        >
          <XIcon className="size-4 stroke-[2.5px] text-white" />
          <span className="font-semibold tracking-wide">
            Cancelled by {cancelledByName}
          </span>
        </Tag>
      );

    default:
      // in case of tour, there are is a phase where first phase approval is done and approval status along with current approver becomes null. Then, the user fills their own expenses and send the claim for approval again (phase 2 approval)
      const isTourCategory =
        data?.travelCategory?.name?.trim().toLowerCase() === 'tour';
      const isNewTourRequest =
        data?.travelSubCategory?.name?.trim().toLowerCase() ===
        'new tour request';

      if (
        isRequestFinalApproved &&
        !isRequestSubmittedForClaimApproval &&
        isTourCategory &&
        isNewTourRequest
      ) {
        return (
          <Tag
            bordered={false}
            className="!px-3 !py-1.5 !text-xs !rounded-lg !shadow-sm flex items-center gap-x-2 bg-gradient-to-r from-cyan-500 to-cyan-600 text-white border border-cyan-400/30"
          >
            <div className="relative flex items-center">
              <div className="absolute h-2 w-2 rounded-full bg-white animate-ping opacity-75"></div>
              <div className="relative h-2 w-2 rounded-full bg-white"></div>
            </div>
            <span className="font-semibold tracking-wide">Tour Approved</span>
          </Tag>
        );
      }
      // For any other status or if status is not set, show "Approval Ongoing"
      return (
        <Tag
          bordered={false}
          className="!px-3 !py-1.5 !text-xs !rounded-lg !shadow-sm flex items-center gap-x-2 bg-gradient-to-r from-amber-500 to-amber-600 text-white border border-amber-400/30"
        >
          <div className="relative flex items-center">
            <div className="absolute h-2 w-2 rounded-full bg-white animate-ping opacity-75"></div>
            <div className="relative h-2 w-2 rounded-full bg-white"></div>
          </div>
          <span className="font-semibold tracking-wide">Approval Ongoing</span>
        </Tag>
      );
  }
};

const APPROVAL_ACTION_MENU_OPTIONS: MenuProps['items'] = [
  {
    label: (
      <div className="flex items-center gap-2">
        <CheckBadgeIcon className="size-4 text-success-400" />
        <span className="text-[11px]">Approve</span>
      </div>
    ),
    key: SystemApprovalAction.APPROVE,
  },
  {
    label: (
      <div className="flex items-center gap-2">
        <HandRaisedIcon className="size-4 text-warning-400" />
        <span className="text-[11px]">Hold</span>
      </div>
    ),
    key: SystemApprovalAction.HOLD,
  },
  {
    label: (
      <div className="flex items-center gap-2">
        <X className="size-4 text-error-400" />
        <span className="text-[11px]">Reject</span>
      </div>
    ),
    key: SystemApprovalAction.REJECT,
  },
  {
    type: 'divider',
  },
  {
    label: (
      <div className="flex items-center gap-2">
        <UserGroupIcon className="size-4 text-primary-400" />
        <span className="text-[11px]">Send for review</span>
      </div>
    ),
    key: SystemApprovalAction.IN_REVIEW,
  },
];

const VIEW_MENU_OPTIONS: MenuProps['items'] = [
  {
    label: (
      <div className="flex items-center gap-2">
        <UsersIcon className="size-3 stroke-[3px] text-[#0089FF]" />
        <span className="text-[11px]">Approval Log</span>
      </div>
    ),
    key: 'approvalLog',
  },
  {
    label: (
      <div className="flex items-center gap-2">
        <Logs className="size-3 stroke-[3px] text-[#0089FF]" />
        <span className="text-[11px]">Change Log</span>
      </div>
    ),
    key: 'changeLog',
  },
  {
    label: (
      <div className="flex items-center gap-2">
        <Server className="size-3 stroke-[3px] text-[#0089FF]" />
        <span className="text-[11px]">SAP Log</span>
      </div>
    ),
    key: 'sapLog',
  },
];

export const sortOptions = [
  {
    label: 'Create At (Ascending)',
    value: LogsSortByOptions.ASC,
  },
  {
    label: 'Create At (Descending)',
    value: LogsSortByOptions.DESC,
  },
];

const TravelReqDetail = () => {
  const [triggerDownloadAttachments, { isLoading: isDownloading }] =
    useLazyDownloadTravelAttachmentsZipQuery();
  const [triggerPrint, { isLoading: isPrinting }] =
    useLazyPrintTravelRequestQuery();
  const [openApprovalConfigForm, setOpenApprovalConfigForm] = useState(false);
  // Form for managing individual approval level configurations
  const approvalConfigForm = useForm<ApprovalHierarchyFormValues>({
    defaultValues: { approvers: [] },
  });
  // API queries for dropdown data
  const employeesResponse = useGetAllUsersQuery();
  const employeeDropdown = useMemo(() => {
    if (employeesResponse.data) {
      const employees = employeesResponse.data?.data || [];
      return mapToDropdownOptions(
        employees,
        ['FullName', 'EmployeeCode'],
        'ID',
      );
    }
    return [];
  }, [employeesResponse.data]);
  const { id } = useParams();
  if (!id) {
    throw new Error('Invalid Travel Request ID');
  }
  if (!parseInt(id?.toString())) {
    throw new Error('Invalid Travel Request ID.');
  }
  const { user } = useAuth();

  const approvalHierarchyManagerRoles: string[] = [
    SystemRoles.ADMIN,
    SystemRoles.TRAVEL_ADMIN,
  ];
  const hasApprovalHierarchyManagerRole = user?.userPanelRoles?.some(item =>
    approvalHierarchyManagerRoles.includes(item?.role?.name),
  );
  const { showNotification } = useNotification();
  const navigate = useNavigate();
  const [requestClaimType, setRequestClaimType] =
    useState<ClaimRequestType>(null);

  const travelReqResponse = useGetTravelRequestByIdQuery(+id, {
    refetchOnMountOrArgChange: true,
  });
  const canManageApprovalHierarchy = Boolean(
    hasApprovalHierarchyManagerRole &&
      travelReqResponse.data?.data?.submissionStatus ===
        SubmissionStatus.SUBMITTED &&
      !travelReqResponse.data?.data?.isClaimFinalApproved &&
      travelReqResponse.data?.data?.approvalStatus !==
        SystemApprovalStatus.REJECTED &&
      travelReqResponse.data?.data?.approvalStatus !==
        SystemApprovalStatus.CANCELLED,
  );
  const [localPaidStatus, setLocalPaidStatus] = useState<boolean>(false);

  const [getFormFieldMapping, formFieldMappingResponse] =
    useLazyGetFormFieldMappingQuery();

  const [isApprovalModalOpen, setIsApprovalModalOpen] =
    useState<boolean>(false);
  const [selectedActionOption, setSelectedActionOption] =
    useState<SystemApprovalAction>(null);
  const [approvalModalConfig, setApprovalModalConfig] =
    useState<IApprovalModalConfig>({
      title: '',
      body: '',
      showReviewers: false,
      reviewers: [],
    });
  const [isTourSendForClaimModalOpen, setIsTourSendForClaimModalOpen] =
    useState(false);
  const [isCancelRequestModalOpen, setIsCancelRequestModalOpen] =
    useState<boolean>(false);
  const [
    isResetApprovalHierarchyModalOpen,
    setIsResetApprovalHierarchyModalOpen,
  ] = useState<boolean>(false);

  const [sendTravelRequestForClaim, sendTravelRequestForClaimResponse] =
    useSendTravelRequestForClaimMutation();

  const [cancelClaimRequest, cancelClaimRequestResponse] =
    useCancelClaimRequestMutation();

  const [updateProcessApprovalAction, updateProcessApprovalActionResponse] =
    useApproveTravelRequestMutation();

  const [updatePaidStatus, { isLoading: isUpdatingPaidStatus }] =
    useUpdateTravelRequestPaidStatusMutation();

  const [lineItemAccordionConfig, setLineItemAccordionConfig] = useState<
    Record<TravelRequestLineItemSection, boolean>
  >({
    [TravelRequestLineItemSection.MODE_OF_JOURNEY]: false,
    [TravelRequestLineItemSection.ACCOMMODATION_TYPE]: false,
    [TravelRequestLineItemSection.EXPENSE_CLAIM]: false,
    [TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM]: false,
    [TravelRequestLineItemSection.PER_DIEM]: false,
    [TravelRequestLineItemSection.PER_KM]: false,
    [TravelRequestLineItemSection.ATTACHMENTS]: false,
    [TravelRequestLineItemSection.HEADER]: false,
  });

  const [tableFilterState, setTableFilterState] = useState<
    Record<string, boolean>
  >({});
  const [tableSortState, setTableSortState] = useState<
    Record<string, { id: string; desc: boolean; key: string } | null>
  >({});

  const toggleSectionFilter = (section: string) => {
    setTableFilterState(prev => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const handleSortChange = (section: string, key: string) => {
    if (key === 'default') {
      setTableSortState(prev => ({ ...prev, [section]: null }));
      return;
    }
    let sortObj: { id: string; desc: boolean; key: string } | null = null;
    if (key === 'date_desc') sortObj = { id: 'fromDate', desc: true, key };
    else if (key === 'date_asc') sortObj = { id: 'fromDate', desc: false, key };
    else if (key === 'amount_desc') {
      const sortId =
        section === TravelRequestLineItemSection.PER_KM ? 'total' : 'amount';
      sortObj = { id: sortId, desc: true, key };
    } else if (key === 'amount_asc') {
      const sortId =
        section === TravelRequestLineItemSection.PER_KM ? 'total' : 'amount';
      sortObj = { id: sortId, desc: false, key };
    }

    setTableSortState(prev => ({ ...prev, [section]: sortObj }));
  };

  // table data states
  const [journeyData, setJourneyData] = useState<IModeOfJourneyForm[]>([]);
  const [accommodationData, setAccommodationData] = useState<
    IAccomodationForm[]
  >([]);
  const [expenseClaimData, setExpenseClaimData] = useState<IExpenseClaimForm[]>(
    [],
  );
  const [officeExpenseClaimData, setOfficeExpenseClaimData] = useState<
    IExpenseClaimForm[]
  >([]);
  const [perDiemData, setPerDiemData] = useState<IPerDiemClaimForm[]>([]);
  const [perKmData, setPerKmData] = useState<IPerKmClaimForm[]>([]);
  const [isApprovalHierarchyOpen, setIsApprovalHierarchyOpen] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  // Sticky header refs and state
  const headerRef = useRef<HTMLDivElement | null>(null);
  const [showStickyHeader, setShowStickyHeader] = useState(false);
  const sentinelRef = useRef<HTMLDivElement | null>(null);

  // table data view more side sheets
  const [showJourneySheet, setShowJourneySheet] = useState<boolean>(false);
  const [isAccommodationSheetOpen, setIsAccommodationSheetOpen] =
    useState<boolean>(false);
  const [isTransactionDetailsSheetOpen, setIsTransactionDetailsSheetOpen] =
    useState<boolean>(false);
  const [showExpenseClaimSheet, setShowExpenseClaimSheet] =
    useState<boolean>(false);
  const [showOfficeExpenseClaimSheet, setShowOfficeExpenseClaimSheet] =
    useState<boolean>(false);
  const [showPerDiemSheet, setShowPerDiemSheet] = useState<boolean>(false);
  const [showPerKmSheet, setShowPerKmSheet] = useState<boolean>(false);
  const [attachmentList, setAttachmentList] = useState<ITravelAttachment[]>([]);
  const [header, setHeader] = useState(null);
  const [formConfig, setFormConfig] = useState(DEFAULT_FORM_FIELD_CONFIG);
  const [permissions, setPermissions] = useState({
    showEdit: false,
    showApprovalAction: false,
    showSendTourForClaim: false,
    showCancel: false,
  });
  const attachmentRecoveryResponse = useGetAttachmentRecoveryQuery(+id, {
    skip: !permissions.showEdit,
  });

  const cancellationForm = useForm<{ remarks: string; attachment: File }>({
    defaultValues: {
      remarks: null,
      attachment: null,
    },
  });

  const [auditData, setAuditData] = useState(null);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 25,
    id: id,
    sortBy: LogsSortByOptions.DESC,
  });
  const [totalLog, setTotalLog] = useState(0);
  const [isLogOpen, setIsLogOpen] = useState(false);

  const [totalChangelog, setTotalChangelog] = useState(0);
  const [filters, setFilters] = useState({
    page: 1,
    pageSize: 25,
    id: id,
    sortBy: LogsSortByOptions.DESC,
  });
  const [isChangelogOpen, setIsChangelogOpen] = useState(false);
  const [totalSapLog, setTotalSapLog] = useState(0);
  const [sapLogFilters, setSapLogFilters] = useState({
    page: 1,
    pageSize: 25,
    id: id,
    sortBy: LogsSortByOptions.DESC,
  });
  const [isSapLogOpen, setIsSapLogOpen] = useState(false);
  const approvalLogData = useGetTravelApprovalLogsByIdQuery(pagination);
  const changeLogData = useGetTravelChangeLogsByIdQuery(filters, {
    skip: !isChangelogOpen,
  });
  const sapLogData = useGetTravelSapLogsByIdQuery(sapLogFilters, {
    skip: !isSapLogOpen,
  });

  // Get the approver who performed the last action (reject/hold/cancel)
  // Backend will provide lastActionApprover based on approval status
  const lastActionApprover = useMemo(() => {
    // First, check if backend provides lastActionApprover directly
    if (travelReqResponse.data?.data?.lastActionApprover) {
      return travelReqResponse.data.data.lastActionApprover?.FullName || null;
    }
    // Fallback: extract from approval logs if backend doesn't provide it yet
    if (!approvalLogData.data?.data?.list?.length) return null;
    const logs = approvalLogData.data.data.list;
    // Find the most recent REJECT, HOLD, or CANCELLED action
    const relevantActions = ['REJECT', 'HOLD', 'CANCELLED'];
    for (const log of logs) {
      if (relevantActions.includes(log.action)) {
        return log.createdByUser?.FullName || null;
      }
    }
    return null;
  }, [travelReqResponse.data, approvalLogData.data]);
  const [attachmentListConfig, setAttachmentListConfig] = useState({
    isOpen: false,
    list: [],
  });
  const [attachmentCarousel, setAttachmentCarousel] = useState<{
    isOpen: boolean;
    attachments: ITravelAttachment[];
  }>({ isOpen: false, attachments: [] });
  const [selectedLineItem, setSelectedLineItem] = useState<any>(null);
  const [selectedSection, setSelectedSection] =
    useState<TravelRequestLineItemSection | null>(null);
  const [pdfUrl, setPdfUrl] = useState(null);

  // --- Cancel Button Visibility Logic ---
  const allowedRoles = [
    SystemRoles.ADMIN,
    SystemRoles.TRAVEL_DESK,
    SystemRoles.TRAVEL_ADMIN,
  ];
  const isCreator = user?.ID === travelReqResponse.data?.data?.employee;
  const hasAllowedRole = user?.userPanelRoles?.some((panelRole: any) =>
    allowedRoles.includes(panelRole?.role?.name),
  );

  const startDate = travelReqResponse.data?.data?.startDate;
  const isWithinCancelWindow = startDate
    ? dayjs().isBefore(dayjs(startDate), 'day')
    : false;

  // Admins can cancel anytime. Creators can only cancel within the date window.
  const canShowCancelButton =
    ((isWithinCancelWindow && isCreator) || hasAllowedRole) &&
    travelReqResponse.data?.data?.approvalStatus !== 'CANCELLED';

  // Setup observer for sticky header visibility using a sentinel just above header
  useEffect(() => {
    const sentinelEl = sentinelRef.current;
    if (!sentinelEl) return;

    const intersectionObserver = new IntersectionObserver(
      entries => {
        const entry = entries[0];
        // Show sticky only when the sentinel is out of view (scrolled past top)
        setShowStickyHeader(!entry.isIntersecting);
      },
      { root: null, threshold: 0 },
    );
    intersectionObserver.observe(sentinelEl);

    return () => {
      intersectionObserver.disconnect();
    };
  }, [travelReqResponse.data]);

  // Sync local state when API data changes
  useEffect(() => {
    if (travelReqResponse.data?.data?.markAsPaid !== undefined) {
      setLocalPaidStatus(
        travelReqResponse.data.data.markAsPaid ===
          TravelRequestMarkAsPaidStatus.PAID ||
          travelReqResponse.data.data.markAsPaid === true,
      );
    }
  }, [travelReqResponse.data?.data?.markAsPaid]);

  useEffect(() => {
    if (
      pagination.page === 1 &&
      approvalLogData.data?.data?.count !== undefined
    ) {
      setTotalLog(approvalLogData.data.data.count);
    }
  }, [pagination.page, approvalLogData.data?.data?.count]);

  useEffect(() => {
    if (filters.page === 1 && changeLogData.data?.data?.count !== undefined) {
      setTotalChangelog(changeLogData.data.data.count);
    }
  }, [filters.page, changeLogData.data?.data?.count]);

  useEffect(() => {
    if (
      sapLogFilters.page === 1 &&
      sapLogData.data?.data?.count !== undefined
    ) {
      setTotalSapLog(sapLogData.data.data.count);
    }
  }, [sapLogFilters.page, sapLogData.data?.data?.count]);

  const approvalForm = useForm<IApprovalForm>({
    defaultValues: {
      remarks: '',
      toLevel: null,
      reviewType: ReviewType.SKIP,
    },
  });

  const handleDownloadAttachments = async () => {
    try {
      const result = await triggerDownloadAttachments({
        travelRequestId: +id,
      }).unwrap();
      if (result) {
        downloadFileFromBlob(
          result,
          `claim-request-${travelReqResponse.data?.data?.requestNo || travelReqResponse?.data?.data?.id}-attachments.zip`,
        );
      }
    } catch (err) {
      showNotification(
        'error',
        'Error',
        extractErrorMessageFromAPI(err) || 'Failed to download attachments.',
      );
    }
  };

  const handlePrint = async () => {
    try {
      const printableContent = await triggerPrint({ id: +id }).unwrap();
      if (printableContent) {
        // Create a blob URL from response
        const blob = new Blob([printableContent], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
      }
    } catch (err) {
      showNotification(
        'error',
        'Error',
        extractErrorMessageFromAPI(err) ||
          'Failed to get printable view. Please try again.',
      );
    }
  };

  async function handleSendTravelRequestForClaimConfirm() {
    try {
      if (travelReqResponse.data?.data) {
        const response = await sendTravelRequestForClaim({
          id: travelReqResponse.data?.data?.id,
        }).unwrap();
        navigate('/travel/all');
        showNotification(
          'success',
          'Claim Sent for Approval',
          response?.message || 'The claim approval hierarchy is now active.',
        );
      }
    } catch (err) {
      showNotification(
        'error',
        'Error',
        extractErrorMessageFromAPI(err) ||
          'Something went wrong . Please try again',
      );
    } finally {
      setIsTourSendForClaimModalOpen(false);
    }
  }

  async function getViewBasedOnFormFieldMapping({
    categoryId,
    subcategoryId,
    requestType,
  }: {
    categoryId: number;
    subcategoryId: number;
    requestType: TourRequestType;
  }) {
    try {
      const response = await getFormFieldMapping({
        categoryId,
        subcategoryId,
        requestType,
      }).unwrap();
      if (Array.isArray(response.data?.list) && response.data?.list?.length) {
        setFormConfig(response.data?.list[0].config);
      } else {
        setFormConfig(DEFAULT_FORM_FIELD_CONFIG);
      }
    } catch (err) {
      console.error(err);
      setFormConfig(DEFAULT_FORM_FIELD_CONFIG);
      showNotification(
        'error',
        'Unable to load form configuration',
        extractErrorMessageFromAPI(err) ||
          'The configured view could not be loaded. Default fields are shown instead.',
      );
    }
  }

  function fetchReviewersList(data: any) {
    /**
     * Handle currentApprovalLevel:
     * - null means CREATOR_LEVEL (0) - request was sent for review to creator
     * - Otherwise, it's the actual level (1, 2, 3, etc.)
     * - When first submitted, currentApprovalLevel is always 1+ (never null)
     *
     * Convert null to CREATOR_LEVEL (0) for comparison purposes
     */
    const currentApprovalLevel = data?.currentApprovalLevel ?? CREATOR_LEVEL;
    const reviewers: any[] = [];

    // Add creator (forEmployee/employee) with CREATOR_LEVEL (0)
    if (data?.forEmployee) {
      reviewers.push({
        id: data?.employee,
        approvalLevel: CREATOR_LEVEL,
        approver: {
          ID: data?.forEmployee?.ID,
          FullName: data?.forEmployee?.FullName || '',
          EmailID: data?.forEmployee?.EmailID || '',
          EmployeeCode: data?.forEmployee?.EmployeeCode || '',
        },
      });
    }

    // Add all past approvers from the hierarchy (approvalLevel < currentApprovalLevel)
    // If currentApprovalLevel is null (CREATOR_LEVEL), we use CREATOR_LEVEL (0) for comparison
    // So we'll show all approvers with level < 0 (which means none from hierarchy, only creator)
    if (data?.claimApprovalHierarchy?.length) {
      const pastApprovers = data.claimApprovalHierarchy.filter(
        (item: any) =>
          item.approvalLevel !== undefined &&
          item.approvalLevel < currentApprovalLevel,
      );

      reviewers.push(...pastApprovers);
    }

    return reviewers;
  }

  useEffect(() => {
    if (travelReqResponse.isSuccess && travelReqResponse.data?.data) {
      const data = travelReqResponse.data?.data;
      const galleryAttachments = mapTravelGalleryAttachments(
        data.attachmentGalleryMappings,
      );
      const headerAttachments = [
        ...(data.travelDocuments || []),
        ...galleryAttachments.filter(
          attachment =>
            attachment.section === TravelRequestLineItemSection.HEADER,
        ),
      ];
      const journeys = mergeTravelGalleryAttachments(
        data.travelModeOfJourneys,
        galleryAttachments,
        () => TravelRequestLineItemSection.MODE_OF_JOURNEY,
      );
      const accommodations = mergeTravelGalleryAttachments(
        data.travelAccommodations,
        galleryAttachments,
        () => TravelRequestLineItemSection.ACCOMMODATION_TYPE,
      );
      const claims = mergeTravelGalleryAttachments(
        data.travelPerClaims,
        galleryAttachments,
        claim =>
          claim.expenseCategory === ExpenseCategory.OFFICE
            ? TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM
            : TravelRequestLineItemSection.EXPENSE_CLAIM,
      );
      const perDiems = mergeTravelGalleryAttachments(
        data.travelPerDiems,
        galleryAttachments,
        () => TravelRequestLineItemSection.PER_DIEM,
      );
      const perKms = mergeTravelGalleryAttachments(
        data.travelPerKms,
        galleryAttachments,
        () => TravelRequestLineItemSection.PER_KM,
      );
      setAttachmentList(headerAttachments);
      setJourneyData(journeys);
      setAccommodationData(accommodations);
      // Separate employee and Company Expenses based on expenseCategory
      const employeeExpenseClaims =
        claims.filter(
          (claim: IExpenseClaimForm) =>
            claim.expenseCategory !== ExpenseCategory.OFFICE,
        ) || [];
      const officeExpenseClaims =
        claims.filter(
          (claim: IExpenseClaimForm) =>
            claim.expenseCategory === ExpenseCategory.OFFICE,
        ) || [];

      setExpenseClaimData(employeeExpenseClaims);
      setOfficeExpenseClaimData(officeExpenseClaims);
      setPerDiemData(perDiems);
      setPerKmData(perKms);
      getViewBasedOnFormFieldMapping({
        categoryId: data?.claimCategory,
        subcategoryId: data?.claimSubCategory,
        requestType: data?.requestType,
      });

      // Update accordion states based on data presence
      setLineItemAccordionConfig(prev => ({
        ...prev,
        [TravelRequestLineItemSection.MODE_OF_JOURNEY]:
          data.travelModeOfJourneys?.length > 0,
        [TravelRequestLineItemSection.ACCOMMODATION_TYPE]:
          data.travelAccommodations?.length > 0,
        [TravelRequestLineItemSection.EXPENSE_CLAIM]:
          employeeExpenseClaims?.length > 0,
        [TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM]:
          officeExpenseClaims?.length > 0,
        [TravelRequestLineItemSection.PER_DIEM]:
          data.travelPerDiems?.length > 0,
        [TravelRequestLineItemSection.PER_KM]: data.travelPerKms?.length > 0,
        [TravelRequestLineItemSection.ATTACHMENTS]:
          headerAttachments.length > 0,
      }));

      setHeader({
        employee: data?.forEmployee?.FullName || '-',
        billToCustomer: data?.billToCustomer ? 'Yes' : 'No',
        claimCategory: data?.travelCategory?.name || '-',
        claimSubCategory: data?.travelSubCategory?.name || '-',
        customer: data?.travelCustomer?.name || '-',
        purposeOfTravel: data?.purposeOfTravel || '-',
        startDate: data?.startDate
          ? formatDayJsDate(dayjs(data?.startDate), 'YYYY-MM-DD')
          : '-',
        endDate: data?.endDate
          ? formatDayJsDate(dayjs(data?.endDate), 'YYYY-MM-DD')
          : '-',
        costCenter: data?.travelCostCenter?.name || '-',
        fromCountry: data?.travelFromCountry?.LongDescription || '-',
        fromCity: data?.travelFromCity?.ShortDescription || '-',
        toCountry: data?.travelToCountry?.LongDescription || '-',
        toCity: data?.travelToCity?.ShortDescription || '-',
        budget: data?.budget ? getFormattedAmount(data?.budget) : '-',
        budgetCurrency: data?.travelBudgetCurrency?.ShortCode || '-',
        advanceAmount: data?.advanceAmount
          ? getFormattedAmount(data?.advanceAmount)
          : '-',
        advanceAmountCurrency: data?.advanceAmountCurrency?.ShortCode || '-',
        remarks: data?.remarks || '-',
        handsetModel: data?.handsetModel || '-',
        imeiNo: data?.imeiNo || '-',
        cost: data?.cost ? getFormattedAmount(data?.cost) : '-',
        dateOfPurchase: data?.dateOfPurchase
          ? formatDayJsDate(dayjs(data?.dateOfPurchase), 'YYYY-MM-DD')
          : '-',
        costCurrency: data?.costCurrency?.ShortCode || '-',
      });

      setRequestClaimType(
        getClaimTypeFromCategories(data?.claimCategory, data?.claimSubCategory),
      );

      const approvalPendingWith = data?.currentApprover;

      setAuditData({
        finalApprovedBy: data?.finalApprovedBy?.FullName || '-',
        submittedOn: data?.submittedOn
          ? formatDayJsDate(dayjs(data?.submittedOn), 'verbose')
          : '-',
        totalAmount: data?.totalAmount
          ? getFormattedAmount(data?.totalAmount)
          : '-',
        approvedAmount: data?.approvedAmount
          ? getFormattedAmount(data?.approvedAmount)
          : '-',
        createdByUser: data?.createdByUser?.FullName
          ? data?.createdByUser?.FullName
          : '-',
        updatedByUser: data?.updatedByUser?.FullName
          ? data?.updatedByUser?.FullName
          : '-',

        createdAt: data?.createdAt
          ? formatDayJsDate(dayjs(data?.createdAt), 'verbose')
          : '-',
        updatedAt: data?.updatedAt
          ? formatDayJsDate(dayjs(data?.updatedAt), 'verbose')
          : '-',
        approvalStatus: data?.isClaimFinalApproved
          ? APPROVAL_STATUS_LABEL_MAP[SystemApprovalStatus.APPROVED]
          : data?.approvalStatus
            ? APPROVAL_STATUS_LABEL_MAP[
                data?.approvalStatus as unknown as SystemApprovalStatus
              ]
            : '-',
        currentApprovalLevel: data?.currentApprovalLevel,
        approver: `${approvalPendingWith?.FullName || '-'}`,
        approverEmployeeCode: `${approvalPendingWith?.EmployeeCode || '-'}`,
        isClaimFinalApproved: data?.isClaimFinalApproved ? 'Yes' : 'No',
        claimFinalApprovedTimeStamp: data?.claimFinalApprovedTimeStamp
          ? formatDayJsDate(dayjs(data?.claimFinalApprovedTimeStamp), 'verbose')
          : '-',
        claimCategory: data?.travelCategory?.name || '-',
        claimSubCategory: data?.travelSubCategory?.name || '-',
        employeeCode: data?.forEmployee?.EmployeeCode || '-',
        requestFinalApprovedTimeStamp: data?.requestFinalApprovedTimeStamp
          ? formatDayJsDate(
              dayjs(data?.requestFinalApprovedTimeStamp),
              'verbose',
            )
          : '-',
        isRequestFinalApproved: data?.isRequestFinalApproved ? 'Yes' : 'No',
        requestFinalApprover: data?.tourFinalApprovedBy?.FullName || '-',
        requestFinalApproverEmployeeCode:
          data?.tourFinalApprovedBy?.EmployeeCode || '-',
        markAsPaid: data?.markAsPaid,
        claimMonth: data?.claimMonth,
        claimYear: data?.claimYear,
        sapDocumentNumber: data?.sapDocumentNumber || '-',
        UTRNo: data?.UTRNo || '-',
        paidAmount: data?.paidAmount
          ? getFormattedAmount(data?.paidAmount)
          : '-',
        sapDocumentDate: data?.sapDocumentDate
          ? formatDayJsDate(dayjs(data?.sapDocumentDate), 'YYYY-MM-DD')
          : '-',
      });

      const canSendTourForClaim =
        data?.isRequestFinalApproved &&
        !data?.isRequestSubmittedForClaimApproval &&
        data?.employee == user?.ID &&
        ![
          SystemApprovalStatus.CANCELLED,
          SystemApprovalStatus.REJECTED,
        ].includes(data.approvalStatus);

      setPermissions({
        showEdit: data?.permissions?.showEdit,
        showApprovalAction: data?.permissions?.showApprovalAction,
        showSendTourForClaim: canSendTourForClaim,
        showCancel: data?.permissions?.showCancel,
      });

      // Update reviewers list if we have hierarchy or a creator (forEmployee)
      if (data?.claimApprovalHierarchy?.length || data?.forEmployee) {
        const prevReviewers = fetchReviewersList(data);
        setApprovalModalConfig(prev => {
          return {
            ...prev,
            reviewers: prevReviewers,
          };
        });
      }
    }
  }, [travelReqResponse.data, user]);

  function handleApprovalAction(actionOption: SystemApprovalAction) {
    let config: IApprovalModalConfig = {
      title: '',
      body: '',
      showReviewers: false,
      reviewers: [],
    };
    if (actionOption === SystemApprovalAction.APPROVE) {
      config = {
        title: 'Approve Request',
        body: <ApproveActionMessage />,
        showReviewers: false,
        reviewers: approvalModalConfig.reviewers,
      };
      approvalForm.setValue('remarks', 'Ok approved');
    } else if (actionOption === SystemApprovalAction.REJECT) {
      config = {
        title: 'Reject Request',
        body: <RejectActionMessage />,
        showReviewers: false,
        reviewers: approvalModalConfig.reviewers,
      };
    } else if (actionOption === SystemApprovalAction.HOLD) {
      config = {
        title: 'Hold Request',
        body: <HoldActionMessage />,
        showReviewers: false,
        reviewers: approvalModalConfig.reviewers,
      };
    } else if (actionOption === SystemApprovalAction.IN_REVIEW) {
      config = {
        title: 'In Review',
        body: <InReviewActionMessage />,
        showReviewers: true,
        reviewers: approvalModalConfig.reviewers,
      };
    }

    setSelectedActionOption(actionOption);
    setApprovalModalConfig(config);
    setIsApprovalModalOpen(true);
  }

  async function handleApprovalConfirm(data: IApprovalForm) {
    try {
      /**
       * Calculate fromLevel for approval action:
       *
       * Logic:
       * - If currentApprovalLevel === null → set to CREATOR_LEVEL (0)
       * - Otherwise → use actual currentApprovalLevel (1, 2, 3, etc.)
       *
       * Important Notes:
       * - currentApprovalLevel is always 1+ when first submitted (first approver level)
       * - currentApprovalLevel can only be null if sent for review back to CREATOR_LEVEL (0)
       * - This happens when a request is sent for review to the creator/employee
       */
      const currentApprovalLevel =
        travelReqResponse.data?.data?.currentApprovalLevel;
      const fromLevel =
        currentApprovalLevel === null || currentApprovalLevel === undefined
          ? CREATOR_LEVEL
          : currentApprovalLevel;

      // Validate toLevel when sending for review (matches backend validation)
      if (selectedActionOption === SystemApprovalAction.IN_REVIEW) {
        // Check if toLevel is undefined or null (but allow 0 for CREATOR_LEVEL)
        if (data.toLevel === undefined || data.toLevel === null) {
          showNotification(
            'error',
            'Error',
            'Please select a reviewer to send for review.',
          );
          return;
        }

        // Backend validation:
        // - If currentApprovalLevel === null (CREATOR_LEVEL), can only send to CREATOR_LEVEL (0)
        // - Otherwise, toLevel must be < currentApprovalLevel and >= CREATOR_LEVEL
        if (
          currentApprovalLevel === null ||
          currentApprovalLevel === undefined
        ) {
          // At CREATOR_LEVEL, can only send to CREATOR_LEVEL
          if (data.toLevel !== CREATOR_LEVEL) {
            showNotification(
              'error',
              'Error',
              'When request is at CREATOR_LEVEL, can only send for review to CREATOR_LEVEL (0).',
            );
            return;
          }
        } else {
          // Normal case: currentApprovalLevel is 1 or higher
          // toLevel must be < currentApprovalLevel and >= CREATOR_LEVEL
          if (
            data.toLevel >= currentApprovalLevel ||
            data.toLevel < CREATOR_LEVEL
          ) {
            showNotification(
              'error',
              'Error',
              'Cannot send for review to a higher or equal level than the current level, or to a level below CREATOR_LEVEL.',
            );
            return;
          }
        }
      }

      await updateProcessApprovalAction({
        id: +id,
        action: selectedActionOption,
        comments: data.remarks,
        reviewConfig: {
          fromLevel: fromLevel,
          toLevel: data.toLevel,
          reviewType: data.reviewType,
          ccUsers: data.ccUsers || [],
        },
      }).unwrap();
      handleApprovalCancel();
      showNotification(
        'success',
        'Success',
        'Request approval request updated successfully.',
      );
    } catch (error) {
      console.error(error);
      showNotification(
        'error',
        'Error',
        extractErrorMessageFromAPI(error) ||
          'Failed to update request approval request. Please try again.',
      );
    }
  }

  function handleApprovalCancel() {
    setIsApprovalModalOpen(false);
    setApprovalModalConfig(prev => {
      return {
        ...prev,
        title: '',
        body: '',
        showReviewers: false,
      };
    });
    setSelectedActionOption(null);
    approvalForm.reset({
      remarks: '',
      toLevel: null,
      reviewType: ReviewType.SKIP,
      ccUsers: [],
    });
  }

  function handlePreview(tableRow: any, section: TravelRequestLineItemSection) {
    setSelectedLineItem(tableRow);
    setSelectedSection(section);

    setAttachmentListConfig({
      isOpen: true,
      list: tableRow.attachments || [],
    });
  }

  function renderAttachmentStatus(row: { original: any }) {
    const rowAttachments = (
      (row.original?.attachments || []) as ITravelAttachment[]
    ).filter(attachment => !attachment.deleteFlag);
    const hasAttachments =
      Boolean(row.original?.hasAttachment) || rowAttachments.length > 0;

    if (!hasAttachments) {
      return (
        <span className="inline-flex items-center gap-1.5 text-xs text-slate-400 font-medium px-1.5 py-0.5">
          —
        </span>
      );
    }

    const count = rowAttachments.length || 1;

    return (
      <Tooltip
        title={`View ${count} ${count === 1 ? 'Attachment' : 'Attachments'}`}
        placement="right"
      >
        <button
          type="button"
          aria-label={`Preview ${count} ${
            count === 1 ? 'Attachment' : 'Attachments'
          }`}
          className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-semibold bg-indigo-50 text-[#5B5CE2] border border-indigo-100/90 shadow-2xs hover:bg-indigo-100/80 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400"
          onClick={event => {
            event.stopPropagation();
            if (rowAttachments.length > 0) {
              setAttachmentCarousel({
                isOpen: true,
                attachments: rowAttachments,
              });
            }
          }}
        >
          <Paperclip className="size-3.5 stroke-[2.25px] text-[#5B5CE2]" />
          <span>
            {count} {count === 1 ? 'File' : 'Files'}
          </span>
        </button>
      </Tooltip>
    );
  }

  function getNextLineItemId(
    currentId: string | number,
    items: any[],
  ): string | number | null {
    const currentIndex = items.findIndex(
      item => String(item.id) === String(currentId),
    );
    if (currentIndex === -1 || currentIndex === items.length - 1) return null;
    return items[currentIndex + 1].id;
  }

  function getPreviousLineItemId(
    currentId: string | number,
    items: any[],
  ): string | number | null {
    const currentIndex = items.findIndex(
      item => String(item.id) === String(currentId),
    );
    if (currentIndex <= 0) return null;
    return items[currentIndex - 1].id;
  }

  function getLineItemsBySection(section: TravelRequestLineItemSection) {
    switch (section) {
      case TravelRequestLineItemSection.EXPENSE_CLAIM:
        return expenseClaimData || [];
      case TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM:
        return officeExpenseClaimData || [];
      case TravelRequestLineItemSection.PER_KM:
        return perKmData || [];
      case TravelRequestLineItemSection.MODE_OF_JOURNEY:
        return journeyData || [];
      case TravelRequestLineItemSection.ACCOMMODATION_TYPE:
        return accommodationData || [];
      case TravelRequestLineItemSection.PER_DIEM:
        return perDiemData || [];
      default:
        return [];
    }
  }

  function handleNavigateToLineItem(
    formName: TravelRequestLineItemSection,
    lineItemId: string | number,
  ) {
    let lineItem;
    switch (formName) {
      case TravelRequestLineItemSection.PER_KM:
        lineItem = perKmData.find(
          item => String(item.id) === String(lineItemId),
        );
        break;
      case TravelRequestLineItemSection.MODE_OF_JOURNEY:
        lineItem = journeyData.find(
          item => String(item.id) === String(lineItemId),
        );
        break;
      case TravelRequestLineItemSection.ACCOMMODATION_TYPE:
        lineItem = accommodationData.find(
          item => String(item.id) === String(lineItemId),
        );
        break;
      case TravelRequestLineItemSection.EXPENSE_CLAIM:
        lineItem = expenseClaimData.find(
          item => String(item.id) === String(lineItemId),
        );
        break;
      case TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM:
        lineItem = officeExpenseClaimData.find(
          item => String(item.id) === String(lineItemId),
        );
        break;
      case TravelRequestLineItemSection.PER_DIEM:
        lineItem = perDiemData.find(
          item => String(item.id) === String(lineItemId),
        );
        break;
    }

    if (lineItem) {
      handlePreview(lineItem, formName);
    }
  }

  // Mode of journey columns and data
  const modeOfJourneyColumns = useMemo(() => {
    const fields = formConfig?.modeOfJourneyForm?.fields || {};

    const columnMap = [
      {
        key: 'attachment',
        header: 'Attachment',
        render: renderAttachmentStatus,
        size: 60,
      },
      {
        key: 'modeOfJourney',
        header: 'Mode of Journey',
        render: (row: any) => row.original.travelModeOfJourney?.name || '-',
      },
      {
        key: 'fromDate',
        header: 'From Date',
        render: (row: any) =>
          row.original.fromDate
            ? formatDayJsDate(convertDateToDayJs(row.original.fromDate))
            : '-',
      },
      {
        key: 'fromTime',
        header: 'From Time',
        render: (row: any) =>
          row.original.fromTime
            ? dayjs(row.original.fromTime, 'HH:mm').format('hh:mm A')
            : '-',
      },
      {
        key: 'fromCountry',
        header: 'From Country',
        render: (row: any) =>
          row.original.travelFromCountry?.LongDescription || '-',
      },
      {
        key: 'fromCity',
        header: 'From City',
        render: (row: any) =>
          row.original.travelFromCity?.ShortDescription || '-',
      },
      {
        key: 'toDate',
        header: 'To Date',
        render: (row: any) =>
          row.original.toDate
            ? formatDayJsDate(convertDateToDayJs(row.original.toDate))
            : '-',
      },
      {
        key: 'toTime',
        header: 'To Time',
        render: (row: any) =>
          row.original.toTime
            ? dayjs(row.original.toTime, 'HH:mm').format('hh:mm A')
            : '-',
      },
      {
        key: 'toCountry',
        header: 'To Country',
        render: (row: any) =>
          row.original.travelToCountry?.LongDescription || '-',
      },
      {
        key: 'toCity',
        header: 'To City',
        render: (row: any) =>
          row.original.travelToCity?.ShortDescription || '-',
      },
      {
        key: 'remarks',
        header: 'Remarks',
        render: (row: any) => (
          <div className="w-[200px] line-clamp-2 text-ellipsis text-wrap">
            <Tooltip title={row.original.remarks || '-'}>
              {row.original.remarks || '-'}
            </Tooltip>
          </div>
        ),
        size: 200,
      },
    ];

    const dynamicColumns: any = columnMap
      .filter(({ key }) => fields[key]?.visible !== false)
      .map(({ key, render, header }) => ({
        accessorKey: key,
        header: () => <span>{header || key}</span>,
        cell: ({ row }: { row: any }) => render(row),
      }));

    // Action column ko sabse pehle rakhna hai taki pinning me gap na aaye
    dynamicColumns.unshift({
      header: () => <span></span>,
      accessorKey: 'actions',
      cell: ({ row }: { row: any }) => (
        <div className="flex items-center gap-2">
          <Tooltip title="View" placement="top">
            <EyeIcon
              onClick={() =>
                handlePreview(
                  row.original,
                  TravelRequestLineItemSection.MODE_OF_JOURNEY,
                )
              }
              className="size-4 cursor-pointer transition-colors hover:text-green-600 stroke-[2px]"
            />
          </Tooltip>
        </div>
      ),
      size: 46,
    });

    return dynamicColumns;
  }, [formConfig]);

  const modeOfJourneyTable = useReactTable({
    data: journeyData,
    columns: modeOfJourneyColumns,
    getCoreRowModel: getCoreRowModel(),
    initialState: {
      columnPinning: {
        left: ['actions'],
      },
    },
    enableColumnPinning: true,
  });

  // Accommodation columns and data
  const accommodationColumns = useMemo(() => {
    const fields = formConfig?.accommodationForm?.fields || {};

    const columnMap = prioritizeTravelAttachmentColumn([
      {
        key: 'attachment',
        header: 'Attachment',
        render: renderAttachmentStatus,
        size: 116,
      },
      {
        key: 'accommodationtype',
        header: 'Accommodation Type',
        render: (row: any) => row.original.travelAccommodation?.name || '-',
      },
      {
        key: 'checkInDate',
        header: 'Check In Date',
        render: (row: any) =>
          row.original.checkInDate
            ? dayjs(row.original.checkInDate).format('YYYY-MM-DD')
            : '-',
      },
      {
        key: 'checkInTime',
        header: 'Check In Time',
        render: (row: any) =>
          row.original.checkInTime
            ? dayjs(row.original.checkInTime, 'HH:mm').format('hh:mm A')
            : '-',
      },
      {
        key: 'checkOutDate',
        header: 'Check Out Date',
        render: (row: any) =>
          row.original.checkOutDate
            ? dayjs(row.original.checkOutDate).format('YYYY-MM-DD')
            : '-',
      },
      {
        key: 'checkOutTime',
        header: 'Check Out Time',
        render: (row: any) =>
          row.original.checkOutTime
            ? dayjs(row.original.checkOutTime, 'HH:mm').format('hh:mm A')
            : '-',
      },
      {
        key: 'country',
        header: 'Country',
        render: (row: any) =>
          row.original.travelToCountry?.LongDescription || '-',
      },
      {
        key: 'city',
        header: 'City',
        render: (row: any) =>
          row.original.travelToCity?.ShortDescription || '-',
      },
      {
        key: 'remarks',
        header: 'Remarks',
        render: (row: any) => (
          <div className="w-[200px] line-clamp-2 text-ellipsis text-wrap">
            <Tooltip title={row.original.remarks || '-'}>
              {row.original.remarks || '-'}
            </Tooltip>
          </div>
        ),
        size: 200,
      },
    ]);

    const dynamicColumns: any = columnMap
      .filter(({ key }) => fields[key]?.visible !== false)
      .map(({ key, render, header }) => ({
        accessorKey: key,
        header: () => <span>{header || key}</span>,
        cell: ({ row }: { row: any }) => render(row),
      }));

    // Action column
    dynamicColumns.push({
      accessorKey: 'actions',
      size: 46,
      header: () => <span></span>,
      cell: ({ row }: { row: any }) => (
        <div className="flex items-center gap-2">
          <Tooltip title="View" placement="top">
            <EyeIcon
              onClick={() =>
                handlePreview(
                  row.original,
                  TravelRequestLineItemSection.ACCOMMODATION_TYPE,
                )
              }
              className="size-4 cursor-pointer transition-colors hover:text-green-600 stroke-[2px]"
            />
          </Tooltip>
        </div>
      ),
    });

    return dynamicColumns;
  }, [formConfig]);

  const accommodationTable = useReactTable({
    data: accommodationData,
    columns: accommodationColumns,
    getCoreRowModel: getCoreRowModel(),
    initialState: {
      columnPinning: {
        left: ['actions'],
      },
    },
  });

  // Expense claims columns and data
  const showBillToCustomerColumn =
    isAdminTypeRole(user) &&
    import.meta.env.VITE_ENV_CLIENT_CODE === ClientCode.SAPPHIRE;
  const showApprovedAmountColumn =
    isAdminTypeRole(user) || travelReqResponse.data?.data?.isClaimFinalApproved;

  const expenseClaimColumns = useMemo(() => {
    const columnMap: any[] = [
      {
        key: 'attachment',
        header: 'Attachment',
        render: renderAttachmentStatus,
        size: 116,
      },
      {
        key: 'expenseType',
        header: 'Expense Type',
        render: (row: any) => row.original.travelExpense?.name || '-',
        size: 180,
      },
      ...(import.meta.env.VITE_ENV_CLIENT_CODE === ClientCode.SAPPHIRE
        ? [
            {
              key: 'customer',
              header: 'Customer',
              render: (row: any) => {
                return row.original.travelCustomer?.name || '-';
              },
            },
          ]
        : []),
      {
        key: 'amount',
        header: 'Amount',
        render: (row: any) => {
          const { hasRefund, amount } = row.original;
          if (hasRefund) {
            return (
              <span style={{ color: 'red' }}>
                -{getFormattedAmount(amount)}
              </span>
            );
          }
          return getFormattedAmount(amount);
        },
        size: 90,
      },
      {
        key: 'date',
        header: 'Date',
        render: (row: any) => {
          const { fromDate, toDate } = row.original || {};
          if (fromDate && toDate) {
            return (
              <div className="flex items-center gap-2">
                <span className="whitespace-nowrap">
                  {dayjs(fromDate).format('YYYY-MM-DD')}
                </span>{' '}
                <span>to</span>
                <span className="whitespace-nowrap">
                  {dayjs(toDate).format('YYYY-MM-DD')}
                </span>
              </div>
            );
          }

          if (fromDate) {
            return (
              <div className="flex items-center gap-2">
                <span className="whitespace-nowrap">
                  {dayjs(fromDate).format('YYYY-MM-DD')}
                </span>
              </div>
            );
          }

          if (toDate) {
            return (
              <div className="flex items-center gap-2">
                <span className="whitespace-nowrap">
                  {dayjs(toDate).format('YYYY-MM-DD')}
                </span>
              </div>
            );
          }

          return <>-</>;
        },
      },
      {
        key: 'city',
        header: 'City',
        render: (row: any) => {
          const { travelFromCity, travelToCity } = row.original || {};
          if (
            travelFromCity?.ShortDescription &&
            travelToCity?.ShortDescription
          ) {
            return (
              <div className="flex items-center gap-2">
                <span className="whitespace-nowrap">
                  {travelFromCity?.ShortDescription}
                </span>{' '}
                <span>to</span>
                <span className="whitespace-nowrap">
                  {travelToCity?.ShortDescription}
                </span>
              </div>
            );
          }

          if (travelFromCity?.ShortDescription) {
            return (
              <div className="flex items-center gap-2">
                <span className="whitespace-nowrap">
                  {travelFromCity?.ShortDescription}
                </span>
              </div>
            );
          }

          if (travelToCity?.ShortDescription) {
            return (
              <div className="flex items-center gap-2">
                <span className="whitespace-nowrap">
                  {travelToCity?.ShortDescription}
                </span>
              </div>
            );
          }

          return <>-</>;
        },
      },
      {
        key: 'Refund Amount',
        render: (row: any) => {
          if (!row.original.cancellationCharges) return '-';
          return (
            <span className="flex items-center gap-1">
              {getFormattedAmount(row.original.cancellationCharges)}
              <Tooltip
                title={row.original.cancellationReason || 'No reason provided'}
              >
                <InfoCircleOutlined
                  style={{ color: '#3C4F76', cursor: 'pointer', fontSize: 12 }}
                />
              </Tooltip>
            </span>
          );
        },
        size: 120,
      },
      // {
      //   key: 'cancellationReason',
      //   header: 'Cancellation Reason',
      //   render: (row: any) => {
      //     return (
      //       <div className="w-[200px] line-clamp-2 text-ellipsis text-wrap">
      //         <Tooltip title={row.original.cancellationReason || '-'}>
      //           {row.original.cancellationReason || '-'}
      //         </Tooltip>
      //       </div>
      //     );
      //   },
      //   size: 200,
      // },
      {
        key: 'remarks',
        header: 'Remarks',
        render: (row: any) => {
          return (
            <div className="w-[200px] line-clamp-2 text-ellipsis text-wrap fon">
              <Tooltip title={row.original.remarks || '-'}>
                {row.original.remarks || '-'}
              </Tooltip>
            </div>
          );
        },
        size: 148,
      },
    ];
    if (showApprovedAmountColumn) {
      columnMap.push({
        key: 'approvedAmount',
        header: 'Approved Amount',
        render: (row: any) =>
          row.original.approvedAmount
            ? getFormattedAmount(row.original.approvedAmount)
            : '-',
        size: 156,
      });
    }
    if (showBillToCustomerColumn) {
      columnMap.unshift({
        key: 'billToCustomer',
        header: 'Bill To Customer',
        render: (row: any) => {
          if (row.original.billToCustomer === true) {
            return (
              <Tooltip title="Bill To Customer: Yes">
                <CheckIcon className="size-5 stroke-[2px] text-success-400" />
              </Tooltip>
            );
          }
          if (row.original.billToCustomer === false) {
            return (
              <Tooltip title="Bill To Customer: No">
                <XMarkIcon className="size-5 stroke-[2px] stroke-error-500 text-error-400" />
              </Tooltip>
            );
          }
          return <span>-</span>;
        },
        size: 148,
      });
    }

    const columns: any = columnMap.map(
      ({
        key,
        render,
        header,
        ...rest
      }: {
        key: string;
        render?: Function;
        header: string;
      }) => ({
        ...rest,
        accessorKey: key,
        header: () => <span>{header || key}</span>,
        cell: ({ row }: { row: any }) => render(row),
      }),
    );

    // Add Action column
    columns.unshift({
      accessorKey: 'actions',
      header: () => <span></span>,
      cell: ({ row }: { row: any }) => (
        <div className="flex items-center gap-2">
          <Tooltip title="View" placement="top">
            <EyeIcon
              onClick={() =>
                handlePreview(
                  row.original,
                  TravelRequestLineItemSection.EXPENSE_CLAIM,
                )
              }
              className="size-4 cursor-pointer transition-colors hover:text-green-600 stroke-[2px]"
            />
          </Tooltip>
        </div>
      ),
      size: 46,
    });

    return columns;
  }, []);

  const expenseClaimTable = useReactTable({
    data: expenseClaimData,
    columns: expenseClaimColumns,
    getCoreRowModel: getCoreRowModel(),
    initialState: {
      columnPinning: {
        left: ['actions'],
      },
    },
  });

  const showBillToCustomerColumnOffice =
    isAdminTypeRole(user) &&
    import.meta.env.VITE_ENV_CLIENT_CODE === ClientCode.SAPPHIRE;
  const showApprovedAmountColumnOffice =
    isAdminTypeRole(user) || travelReqResponse.data?.data?.isClaimFinalApproved;

  const OfficeExpenseClaimColumns = useMemo(() => {
    const columnMap: any[] = [
      {
        key: 'attachment',
        header: 'Attachment',
        render: renderAttachmentStatus,
        size: 116,
      },
      {
        key: 'expenseType',
        header: 'Expense Type',
        render: (row: any) => row.original.travelExpense?.name || '-',
        size: 180,
      },
      {
        key: 'isException',
        header: 'Is Exception',
        render: (row: any) => {
          return row.original.isException ? 'Yes' : 'No';
        },
      },
      ...(import.meta.env.VITE_ENV_CLIENT_CODE === ClientCode.SAPPHIRE
        ? [
            {
              key: 'customer',
              header: 'Customer',
              render: (row: any) => {
                return row.original.travelCustomer?.name || '-';
              },
            },
          ]
        : []),
      {
        key: 'amount',
        header: 'Amount',
        render: (row: any) => {
          const { hasRefund, amount } = row.original;
          if (hasRefund) {
            return (
              <span style={{ color: 'red' }}>
                -{getFormattedAmount(amount)}
              </span>
            );
          }
          return getFormattedAmount(amount);
        },
        size: 87,
      },
      {
        key: 'date',
        header: 'Date',
        render: (row: any) => {
          const { fromDate, toDate } = row.original || {};
          if (fromDate && toDate) {
            return (
              <div className="flex items-center gap-2">
                <span className="whitespace-nowrap">
                  {dayjs(fromDate).format('YYYY-MM-DD')}
                </span>{' '}
                <span>to</span>
                <span className="whitespace-nowrap">
                  {dayjs(toDate).format('YYYY-MM-DD')}
                </span>
              </div>
            );
          }

          if (fromDate) {
            return (
              <div className="flex items-center gap-2">
                <span className="whitespace-nowrap">
                  {dayjs(fromDate).format('YYYY-MM-DD')}
                </span>
              </div>
            );
          }

          if (toDate) {
            return (
              <div className="flex items-center gap-2">
                <span className="whitespace-nowrap">
                  {dayjs(toDate).format('YYYY-MM-DD')}
                </span>
              </div>
            );
          }

          return <>-</>;
        },
      },
      {
        key: 'city',
        header: 'City',
        render: (row: any) => {
          const { travelFromCity, travelToCity } = row.original || {};
          if (
            travelFromCity?.ShortDescription &&
            travelToCity?.ShortDescription
          ) {
            return (
              <div className="flex items-center gap-2">
                <span className="whitespace-nowrap">
                  {travelFromCity?.ShortDescription}
                </span>{' '}
                <span>to</span>
                <span className="whitespace-nowrap">
                  {travelToCity?.ShortDescription}
                </span>
              </div>
            );
          }

          if (travelFromCity?.ShortDescription) {
            return (
              <div className="flex items-center gap-2">
                <span className="whitespace-nowrap">
                  {travelFromCity?.ShortDescription}
                </span>
              </div>
            );
          }

          if (travelToCity?.ShortDescription) {
            return (
              <div className="flex items-center gap-2">
                <span className="whitespace-nowrap">
                  {travelToCity?.ShortDescription}
                </span>
              </div>
            );
          }

          return <>-</>;
        },
      },
      {
        key: 'Refund Amount',
        render: (row: any) => {
          if (!row.original.cancellationCharges) return '-';
          return (
            <span className="flex items-center gap-1">
              {getFormattedAmount(row.original.cancellationCharges)}
              <Tooltip
                title={row.original.cancellationReason || 'No reason provided'}
              >
                <InfoCircleOutlined
                  style={{ color: '#3C4F76', cursor: 'pointer', fontSize: 12 }}
                />
              </Tooltip>
            </span>
          );
        },
        size: 120,
      },
      // {
      //   key: 'cancellationReason',
      //   header: 'Cancellation Reason',
      //   render: (row: any) => {
      //     return (
      //       <div className="w-[200px] line-clamp-2 text-ellipsis text-wrap">
      //         <Tooltip title={row.original.cancellationReason || '-'}>
      //           {row.original.cancellationReason || '-'}
      //         </Tooltip>
      //       </div>
      //     );
      //   },
      //   size: 200,
      // },
      {
        key: 'remarks',
        header: 'Remarks',
        render: (row: any) => {
          return (
            <div className="w-[200px] line-clamp-2 text-ellipsis text-wrap fon">
              <Tooltip title={row.original.remarks || '-'}>
                {row.original.remarks || '-'}
              </Tooltip>
            </div>
          );
        },
        size: 148,
      },
    ];
    if (showApprovedAmountColumnOffice) {
      columnMap.push({
        key: 'approvedAmount',
        header: 'Approved Amount',
        render: (row: any) =>
          row.original.approvedAmount
            ? getFormattedAmount(row.original.approvedAmount)
            : '-',
        size: 156,
      });
    }
    if (showBillToCustomerColumnOffice) {
      columnMap.unshift({
        key: 'billToCustomer',
        header: 'Bill To Customer',
        render: (row: any) => {
          if (row.original.billToCustomer === true) {
            return (
              <Tooltip title="Bill To Customer: Yes">
                <CheckIcon className="size-5 stroke-[2px] text-success-400" />
              </Tooltip>
            );
          }
          if (row.original.billToCustomer === false) {
            return (
              <Tooltip title="Bill To Customer: No">
                <XMarkIcon className="size-5 stroke-[2px] stroke-error-500 text-error-400" />
              </Tooltip>
            );
          }
          return <span>-</span>;
        },
        size: 148,
      });
    }

    const columns: any = columnMap.map(
      ({
        key,
        render,
        header,
        ...rest
      }: {
        key: string;
        render?: Function;
        header: string;
      }) => ({
        ...rest,
        accessorKey: key,
        header: () => <span>{header || key}</span>,
        cell: ({ row }: { row: any }) => render(row),
      }),
    );

    // Add Action column
    columns.unshift({
      accessorKey: 'actions',
      header: () => <span></span>,
      cell: ({ row }: { row: any }) => (
        <div className="flex items-center gap-2">
          <Tooltip title="View" placement="top">
            <EyeIcon
              onClick={() =>
                handlePreview(
                  row.original,
                  TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM,
                )
              }
              className="size-4 cursor-pointer transition-colors hover:text-green-600 stroke-[2px]"
            />
          </Tooltip>
        </div>
      ),
      size: 46,
    });

    return columns;
  }, []);

  // Company Expense Table
  const officeExpenseClaimTable = useReactTable({
    data: officeExpenseClaimData,
    columns: OfficeExpenseClaimColumns, // Reuse the same columns
    getCoreRowModel: getCoreRowModel(),
    initialState: {
      columnPinning: {
        left: ['actions'],
      },
    },
  });

  // Per Diem claims columns and data
  const perDiemColumns = useMemo(() => {
    const fields = formConfig?.perDiemForm?.fields || {};

    const columnMap = [
      {
        key: 'attachment',
        header: 'Attachment',
        render: renderAttachmentStatus,
        size: 60,
      },
      {
        key: 'city',
        header: 'City',
        render: (row: any) =>
          row.original.travelToCity?.ShortDescription || '-',
      },
      {
        key: 'fromDate',
        header: 'From Date',
        render: (row: any) =>
          row.original.fromDate
            ? formatDayJsDate(convertDateToDayJs(row.original.fromDate))
            : '-',
      },
      {
        key: 'toDate',
        header: 'To Date',
        render: (row: any) =>
          row.original.toDate
            ? formatDayJsDate(convertDateToDayJs(row.original.toDate))
            : '-',
      },
      {
        key: 'noOfDays',
        header: 'No. of Days',
        render: (row: any) => row.original?.noOfDays || '-',
      },
      {
        key: 'rate',
        header: 'Rate',
        render: (row: any) =>
          row.original?.rate ? getFormattedAmount(row.original?.rate) : '-',
      },
      {
        key: 'total',
        header: 'Total',
        render: (row: any) =>
          row.original?.total ? getFormattedAmount(row.original?.total) : '-',
      },
      {
        key: 'remarks',
        header: 'Remarks',
        render: (row: any) => (
          <div className="w-[200px] line-clamp-2 text-ellipsis text-wrap">
            <Tooltip title={row.original.remarks || '-'}>
              {row.original.remarks || '-'}
            </Tooltip>
          </div>
        ),
        size: 200,
      },
    ];

    const dynamicColumns: any = columnMap
      .filter(({ key }) => fields[key]?.visible !== false)
      .map(({ key, render, header }) => ({
        accessorKey: key,
        header: () => <span>{header || key}</span>,
        cell: ({ row }: { row: any }) => render(row),
      }));

    // Action column (always shown)
    dynamicColumns.push({
      accessorKey: 'actions',
      header: () => <span></span>,
      cell: ({ row }: { row: any }) => (
        <div className="flex items-center gap-2">
          <Tooltip title="View" placement="top">
            <EyeIcon
              onClick={() =>
                handlePreview(
                  row.original,
                  TravelRequestLineItemSection.PER_DIEM,
                )
              }
              className="size-4 cursor-pointer transition-colors hover:text-green-600 stroke-[2px]"
            />
          </Tooltip>
        </div>
      ),
      size: 46,
    });

    return dynamicColumns;
  }, [formConfig]);

  const perDiemTable = useReactTable({
    data: perDiemData,
    columns: perDiemColumns,
    getCoreRowModel: getCoreRowModel(),
    initialState: {
      columnPinning: {
        left: ['actions'],
      },
    },
    enableColumnPinning: true,
  });

  // Columns definition for Conveyance Claims Table
  const perKmColumns = useMemo(() => {
    const fields = formConfig?.perKmForm?.fields || {};
    const showApprovedAmount =
      isAdminTypeRole(user) ||
      travelReqResponse.data?.data?.isClaimFinalApproved;

    const columnMap = [
      {
        key: 'attachment',
        header: 'Attachment',
        render: renderAttachmentStatus,
        size: 60,
      },
      {
        key: 'modeOfTransport',
        header: 'Mode of Transport',
        render: (row: any) => row.original.travelModeofTransport?.name || '-',
      },
      ...(showApprovedAmount
        ? [
            {
              key: 'approvedAmount',
              header: 'Approved Amount',
              render: (row: any) =>
                row.original.approvedAmount
                  ? getFormattedAmount(row.original.approvedAmount)
                  : '-',
            },
          ]
        : []),
      {
        key: 'total',
        header: 'Total',
        render: (row: any) =>
          row.original.total ? getFormattedAmount(row.original.total) : '-',
      },
      {
        key: 'fromDate',
        header: 'From Date',
        render: (row: any) =>
          formatDayJsDate(convertDateToDayJs(row.original.fromDate)) || '-',
      },
      {
        key: 'toDate',
        header: 'To Date',
        render: (row: any) =>
          formatDayJsDate(convertDateToDayJs(row.original.toDate)) || '-',
      },
      {
        key: 'source',
        header: 'Source',
        render: (row: any) => (
          <div className="w-[130px] line-clamp-2 text-ellipsis text-wrap">
            <Tooltip title={row.original.source || '-'}>
              {row.original.source || '-'}
            </Tooltip>
          </div>
        ),
        size: 130,
      },
      {
        key: 'destination',
        header: 'Destination',
        render: (row: any) => (
          <div className="w-[130px] line-clamp-2 text-ellipsis text-wrap">
            <Tooltip title={row.original.destination || '-'}>
              {row.original.destination || '-'}
            </Tooltip>
          </div>
        ),
        size: 130,
      },
      {
        key: 'distanceInKm',
        header: 'Distance (Km)',
        render: (row: any) =>
          row.original.distanceInKm
            ? formatNumber(row.original.distanceInKm)
            : '-',
      },
      {
        key: 'ratePerKm',
        header: 'Rate Per Km',
        render: (row: any) =>
          row.original.ratePerKm
            ? getFormattedAmount(row.original.ratePerKm)
            : '-',
      },

      {
        key: 'fromMeter',
        header: 'From Meter',
        render: (row: any) =>
          row.original?.fromMeter ? formatNumber(row.original?.fromMeter) : '-',
      },
      {
        key: 'toMeter',
        header: 'To Meter',
        render: (row: any) =>
          row.original?.toMeter ? formatNumber(row.original?.toMeter) : '-',
      },
      {
        key: 'remarks',
        header: 'Remarks',
        render: (row: any) => (
          <div className="w-[200px] line-clamp-2 text-ellipsis text-wrap">
            <Tooltip title={row.original.remarks || '-'}>
              {row.original.remarks || '-'}
            </Tooltip>
          </div>
        ),
        size: 200,
      },
    ];

    const dynamicColumns: any = columnMap
      .filter(({ key }) => fields[key]?.visible !== false)
      .map(({ key, render, header }) => ({
        accessorKey: key,
        header: () => <span>{header || key}</span>,
        cell: ({ row }: { row: any }) => render(row),
      }));

    // Add Action column at the end
    dynamicColumns.push({
      header: () => <span></span>,
      accessorKey: 'actions',
      cell: ({ row }: { row: any }) => (
        <div className="flex items-center gap-2">
          <Tooltip title="View" placement="top">
            <EyeIcon
              onClick={() =>
                handlePreview(row.original, TravelRequestLineItemSection.PER_KM)
              }
              className="size-4 cursor-pointer transition-colors hover:text-green-600 stroke-[2px]"
            />
          </Tooltip>
        </div>
      ),
      size: 46,
    });

    return dynamicColumns;
  }, [formConfig]);

  const perKmTable = useReactTable({
    data: perKmData,
    columns: perKmColumns,
    getCoreRowModel: getCoreRowModel(),
    initialState: {
      columnPinning: {
        left: ['actions'],
      },
    },
  });

  const approvalLogColumns = [
    {
      accessorKey: 'createdByUser',
      header: () => <span>Approver</span>,
      cell: ({ row }: any) => {
        if (
          row.original?.createdByUser?.FullName &&
          row.original?.createdByUser?.EmployeeCode
        ) {
          return `${row.original?.createdByUser?.FullName} - ${row.original?.createdByUser?.EmployeeCode}`;
        }
        return `${row.original?.createdByUser?.FullName}`;
      },
    },
    {
      accessorKey: 'createdAt',
      header: () => <span>Created At</span>,
      cell: (info: any) => (
        <span>
          {info.getValue()
            ? formatDayJsDate(dayjs(info.getValue()), 'verbose')
            : '-'}
        </span>
      ),
    },
    {
      accessorKey: 'comments',
      header: () => <span>Comments</span>,
      cell: (info: any) => {
        return (
          <div className="w-[200px] line-clamp-2 text-ellipsis text-wrap">
            <Tooltip title={info.getValue() || '-'}>
              {info.getValue() || '-'}
            </Tooltip>
          </div>
        );
      },
      size: 200,
    },
    {
      accessorKey: 'action',
      header: () => <span>Action</span>,
      cell: (info: any) => info.getValue() || '-',
      size: 132,
    },
    {
      accessorKey: 'statusCode',
      header: () => <span>Code</span>,
      cell: (info: any) => info.getValue() || '-',
    },
  ];

  const changeLogColumns = [
    {
      accessorKey: 'changeByUser',
      header: () => <span>Change By</span>,
      cell: ({ row }: any) => {
        if (
          row.original?.changeByUser?.FullName &&
          row.original?.changeByUser?.EmployeeCode
        ) {
          return `${row.original?.changeByUser?.FullName} - ${row.original?.changeByUser?.EmployeeCode}`;
        }
        return `${row.original?.changeByUser?.FullName}`;
      },
    },
    {
      accessorKey: 'fieldName',
      header: () => <span>Field Name</span>,
      cell: (info: any) => info.getValue() || '-',
    },
    {
      accessorKey: 'oldValue',
      header: () => <span>Old value</span>,
      cell: (info: any) => {
        const value = info.getValue() as string;
        const displayText =
          value?.length > 30 ? `${value.slice(0, 30)}...` : value || '-';
        return value ? (
          <Popover content={value} title="Old Value">
            <span style={{ cursor: 'pointer' }}>{displayText}</span>
          </Popover>
        ) : (
          '-'
        );
      },
    },
    {
      accessorKey: 'newValue',
      header: () => <span>New value</span>,
      cell: (info: any) => {
        const value = info.getValue() as string;
        const displayText =
          value?.length > 30 ? `${value.slice(0, 30)}...` : value || '-';
        return value ? (
          <Popover content={value} title="New Value">
            <span style={{ cursor: 'pointer' }}>{displayText}</span>
          </Popover>
        ) : (
          '-'
        );
      },
    },
    {
      accessorKey: 'actionType',
      header: () => <span>Action</span>,
      cell: (info: any) => info.getValue() || '-',
      size: 132,
    },
    {
      accessorKey: 'lineItemId',
      header: () => <span>Line Item Id</span>,
      cell: (info: any) => info.getValue() || '-',
    },
    {
      accessorKey: 'lineItemType',
      header: () => <span>Line Item Type</span>,
      cell: (info: any) => info.getValue() || '-',
    },
    {
      accessorKey: 'createdAt',
      header: () => <span>Created At</span>,
      cell: (info: any) => (
        <span>
          {info.getValue()
            ? formatDayJsDate(dayjs(info.getValue()), 'verbose')
            : '-'}
        </span>
      ),
    },
  ];

  const memoizedLogs = useMemo(() => {
    return approvalLogData.data?.data?.list || [];
  }, [approvalLogData.data]);

  const logTable = useReactTable({
    data: memoizedLogs,
    columns: approvalLogColumns,
    getCoreRowModel: getCoreRowModel(),
  });

  const changelogTable = useReactTable({
    data: changeLogData?.data?.data?.list,
    columns: changeLogColumns,
    getCoreRowModel: getCoreRowModel(),
  });

  const memoizedSapLog = useMemo(() => {
    return sapLogData?.data?.data?.list || [];
  }, [sapLogData?.data]);

  // Component to display user info for pushedById - same format as approval/change logs
  const PushedByUserCell = ({
    pushedBy,
    pushedById,
  }: {
    pushedBy: string;
    pushedById: number | null;
  }) => {
    const { data: userData } = useGetEmployeeByIdQuery(pushedById || 0, {
      skip: !pushedById || pushedBy !== 'USER',
    });

    if (pushedBy === 'SYSTEM') {
      return <span>SYSTEM</span>;
    }

    if (pushedBy === 'USER' && pushedById) {
      if (userData?.data) {
        const user = userData.data;
        // Same format as approval/change logs: "FullName - EmployeeCode" or just "FullName"
        if (user?.FullName && user?.EmployeeCode) {
          return `${user.FullName} - ${user.EmployeeCode}`;
        }
        return user?.FullName || '-';
      }
      // Don't show loading, just show empty or fallback
      return <span>-</span>;
    }

    return <span>{pushedBy || '-'}</span>;
  };

  const sapLogColumns = [
    {
      accessorKey: 'pushedBy',
      header: () => <span>Pushed By</span>,
      cell: ({ row }: any) => {
        return (
          <PushedByUserCell
            pushedBy={row.original?.pushedBy || '-'}
            pushedById={row.original?.pushedById}
          />
        );
      },
    },
    {
      accessorKey: 'PushType',
      header: () => <span>Push Type</span>,
      cell: (info: any) => info.getValue() || '-',
    },
    {
      accessorKey: 'createdAt',
      header: () => <span>Created At</span>,
      cell: (info: any) => (
        <span>
          {info.getValue()
            ? formatDayJsDate(dayjs(info.getValue()), 'verbose')
            : '-'}
        </span>
      ),
    },
    {
      accessorKey: 'headerId',
      header: () => <span>Header ID</span>,
      cell: (info: any) => info.getValue() || '-',
    },
  ];

  const sapLogTable = useReactTable({
    data: memoizedSapLog,
    columns: sapLogColumns,
    getCoreRowModel: getCoreRowModel(),
  });

  const handleTourSendForClaimBtnClick = () => {
    setIsTourSendForClaimModalOpen(true);
  };

  const handleCanceRequestClick = () => {
    setIsCancelRequestModalOpen(true);
  };

  // Toggle handler with optimistic updates
  const handleMarkAsPaidToggle = async (checked: boolean) => {
    if (!id) return;

    const newStatus = checked
      ? TravelRequestMarkAsPaidStatus.PAID
      : TravelRequestMarkAsPaidStatus.UNPAID;
    setLocalPaidStatus(checked);

    try {
      await updatePaidStatus({
        requestIds: [Number(id)],
        status: newStatus,
      }).unwrap();

      messageApi.open({
        type: 'success',
        content: `Successfully marked as ${checked ? 'paid' : 'unpaid'}`,
      });
    } catch (error) {
      setLocalPaidStatus(!checked);
      showNotification('error', 'Error', extractErrorMessageFromAPI(error));
    }
  };

  const handleCancelRequestConfirm = async (data: {
    remarks: string;
    attachment: File;
  }) => {
    try {
      if (travelReqResponse.data?.data) {
        const formData = new FormData();

        // Add the file(s) — if `attachment` is a single file
        formData.append('file', data?.attachment);

        formData.append('remarks', data?.remarks);

        // Call the API with FormData
        const response = await cancelClaimRequest({
          id: travelReqResponse.data?.data?.id,
          formData,
        }).unwrap();
        showNotification(
          'success',
          'Success',
          response?.message || 'Request cancelled successfully',
        );
      }
    } catch (err) {
      showNotification(
        'error',
        'Error',
        extractErrorMessageFromAPI(err) ||
          'Something went wrong . Please try again',
      );
    } finally {
      setIsCancelRequestModalOpen(false);
    }
  };

  function handleApprovalHierarchyClick() {
    setIsApprovalHierarchyOpen(true);
  }

  const parsedApprovalActionMenuOptions = useMemo(() => {
    if (travelReqResponse.data && !travelReqResponse.isFetching) {
      return APPROVAL_ACTION_MENU_OPTIONS.filter(item => {
        if (
          item.key === SystemApprovalAction.IN_REVIEW ||
          item.key === SystemApprovalAction.HOLD
        ) {
          if (
            travelReqResponse.data?.data?.approvalStatus ===
              SystemApprovalStatus.IN_REVIEW &&
            travelReqResponse.data?.data?.currentApprovalLevel === null &&
            permissions.showApprovalAction
          ) {
            return false;
          }
          return true;
        }
        return true;
      });
    }

    return [];
  }, [travelReqResponse.data, permissions]);

  const handleAttachmentListClose = () => {
    setAttachmentListConfig({
      isOpen: false,
      list: [],
    });
    setSelectedLineItem(null);
    setSelectedSection(null);
  };

  const totalPerKmAmount = useMemo(() => {
    if (!perKmData || perKmData.length === 0) return 0;

    return perKmData.reduce((sum, item) => {
      if (item && typeof +item.total === 'number') {
        return sum + parseFloat(item.total);
      }
      return sum;
    }, 0);
  }, [perKmData]);

  const totalExpenseClaimAmount = useMemo(() => {
    if (!expenseClaimData || expenseClaimData.length === 0) return 0;

    // Group by expense type (by value or fallback to 'unknown')
    const grouped: Record<string, IExpenseClaimForm[]> = {};
    expenseClaimData.forEach(item => {
      const key = item.expenseType?.value || 'unknown';
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(item);
    });

    let total = 0;
    Object.values(grouped).forEach((items: IExpenseClaimForm[]) => {
      // Find all normal (non-cancellation, non-refund) items
      const normalItems = items.filter(i => !i.isCancellation && !i.hasRefund);
      // Find all cancellation/refund items
      const cancelItems = items.filter(i => i.isCancellation || i.hasRefund);

      // Sum all normal and all cancellation/refund amounts (handle multiple line items)
      const normalAmount = normalItems.reduce(
        (sum, i) => sum + (parseFloat(i.amount) || 0),
        0,
      );
      const cancelAmount = cancelItems.reduce(
        (sum, i) => sum + (parseFloat(i.amount) || 0),
        0,
      );

      total += normalAmount - cancelAmount;
    });
    return total;
  }, [expenseClaimData]);

  function handleLineItemAccordionClick(
    formName: TravelRequestLineItemSection,
  ) {
    setLineItemAccordionConfig(prev => ({
      ...prev,
      [formName]: !prev[formName],
    }));
  }

  let content = (
    <>
      {/* Sticky header (appears when original header is out of view) */}
      {/* Sentinel: sits right above the main header to detect scroll past */}
      <div ref={sentinelRef} aria-hidden="true" className="h-0" />
      <div className="p-2.5 flex flex-col gap-y-2.5">
        <div
          className={`sticky inset-x-0 top-0 z-20 print:hidden ${
            showStickyHeader ? 'block' : 'hidden'
          }`}
        >
          <div className="w-full">
            <div className="w-full border-b border-gray-200 bg-white shadow-sm">
              <div className="px-4 py-2">
                <div className="flex items-center justify-between gap-4 flex-wrap min-h-[2rem]">
                  <div className="flex items-center gap-3 flex-wrap min-w-0">
                    <button
                      type="button"
                      onClick={() => navigate(-1)}
                      className="p-1 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 shrink-0"
                      aria-label="Back"
                    >
                      <ArrowLeftIcon className="w-4 h-4" />
                    </button>
                    {/* <h1 className="text-lg font-bold text-gray-900 tracking-tight uppercase truncate">
                      Travel Request
                    </h1> */}
                    {(travelReqResponse.data?.data?.requestNo ||
                      travelReqResponse.data?.data?.tempRequestNo) && (
                      <span className="inline-flex items-center text-lg font-bold text-gray-900 tracking-tight shrink-0">
                        {travelReqResponse.data?.data?.requestNo ||
                          travelReqResponse.data?.data?.tempRequestNo}
                      </span>
                    )}
                  </div>
                  <div className="flex items-center gap-1 sm:gap-2 flex-wrap justify-end ml-auto">
                    {travelReqResponse.data?.data?.submissionStatus ===
                    SubmissionStatus.SUBMITTED
                      ? renderApprovalStatusBadge(
                          travelReqResponse.data?.data,
                          lastActionApprover,
                        )
                      : null}
                    {canShowCancelButton &&
                      requestClaimType === ClaimRequestType.TRAVEL &&
                      travelReqResponse.data?.data?.submissionStatus ===
                        SubmissionStatus.SUBMITTED &&
                      !travelReqResponse.data?.data
                        ?.isRequestSubmittedForClaimApproval && (
                        <button
                          type="button"
                          onClick={handleCanceRequestClick}
                          className="inline-flex items-center justify-center gap-1.5 min-h-[2rem] px-3 py-1.5 text-xs font-semibold rounded-lg bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors"
                        >
                          <XMarkIcon className="w-3.5 h-3.5 shrink-0 stroke-[2.5px]" />
                          <span>Cancel</span>
                        </button>
                      )}
                    {travelReqResponse.data?.data?.hasAttachment && (
                      <button
                        type="button"
                        onClick={handleDownloadAttachments}
                        disabled={isDownloading}
                        className="inline-flex items-center gap-1.5 text-xs text-gray-500 hover:text-gray-800 hover:bg-gray-50 disabled:opacity-50 px-1.5 py-1.5 rounded-md transition-colors"
                      >
                        <PaperClipIcon className="w-3.5 h-3.5 text-gray-500" />
                        <span>
                          {isDownloading ? 'Downloading...' : 'Attachments'}
                        </span>
                      </button>
                    )}
                    {travelReqResponse.data?.data?.submissionStatus ===
                      SubmissionStatus.SUBMITTED && (
                      <button
                        type="button"
                        onClick={handlePrint}
                        disabled={isPrinting}
                        className="inline-flex items-center gap-1.5 text-xs text-gray-500 hover:text-gray-800 hover:bg-gray-50 disabled:opacity-50 px-1.5 py-1.5 rounded-md transition-colors"
                      >
                        <Printer className="w-3.5 h-3.5 text-gray-500" />
                        <span>{isPrinting ? 'Generating...' : 'Print'}</span>
                      </button>
                    )}
                    {travelReqResponse.data?.data?.submissionStatus ===
                      SubmissionStatus.SUBMITTED && (
                      <button
                        type="button"
                        onClick={() => setIsApprovalHierarchyOpen(true)}
                        className="inline-flex items-center gap-1.5 text-xs text-gray-500 hover:text-gray-800 hover:bg-gray-50 px-1.5 py-1.5 rounded-md transition-colors"
                      >
                        <Network className="w-3.5 h-3.5 text-gray-500" />
                        <span>Hierarchy</span>
                      </button>
                    )}
                    {travelReqResponse.data?.data?.submissionStatus ===
                      SubmissionStatus.SUBMITTED && (
                      <Dropdown
                        menu={{
                          items: VIEW_MENU_OPTIONS,
                          onClick: ({ key }) => {
                            if (key === 'approvalLog') {
                              setIsLogOpen(true);
                              setPagination(prev => ({ ...prev, page: 1 }));
                            } else if (key === 'changeLog') {
                              setIsChangelogOpen(true);
                              setPagination(prev => ({ ...prev, page: 1 }));
                            } else if (key === 'sapLog') {
                              setIsSapLogOpen(true);
                              setSapLogFilters(prev => ({ ...prev, page: 1 }));
                            }
                          },
                        }}
                        trigger={['click']}
                      >
                        <button
                          type="button"
                          className="inline-flex items-center gap-1.5 text-xs text-gray-500 hover:text-gray-800 hover:bg-gray-50 px-1.5 py-1.5 rounded-md transition-colors"
                        >
                          <Logs className="w-3.5 h-3.5 text-gray-500" />
                          <span>Logs</span>
                          <ArrowDown className="w-3 h-3 text-gray-500" />
                        </button>
                      </Dropdown>
                    )}
                    {permissions.showApprovalAction &&
                      (travelReqResponse.data?.data?.approvalStatus ===
                        SystemApprovalStatus.IN_REVIEW &&
                      travelReqResponse.data?.data?.currentApprovalLevel ===
                        null &&
                      travelReqResponse.data?.data?.employee == user?.ID ? (
                        <button
                          type="button"
                          onClick={() =>
                            handleApprovalAction(SystemApprovalAction.APPROVE)
                          }
                          className="inline-flex items-center justify-center gap-1.5 min-h-[2rem] px-3 py-1.5 text-xs font-semibold rounded-lg bg-blue-600 text-white hover:bg-blue-700"
                        >
                          <CheckBadgeIcon className="w-3.5 h-3.5 shrink-0" />
                          <span>Send for Approval</span>
                        </button>
                      ) : (
                        <Dropdown
                          menu={{
                            items: parsedApprovalActionMenuOptions,
                            onClick: ({ key }) => {
                              handleApprovalAction(
                                key as unknown as SystemApprovalAction,
                              );
                            },
                          }}
                          trigger={['click']}
                        >
                          <button
                            type="button"
                            className="inline-flex items-center justify-center gap-1.5 min-h-[2rem] px-3 py-1.5 text-xs font-semibold rounded-lg bg-gray-800 text-white hover:bg-gray-900"
                          >
                            <span>Take Action</span>
                            <ArrowDown className="w-3 h-3 shrink-0" />
                          </button>
                        </Dropdown>
                      ))}
                    {permissions.showSendTourForClaim && (
                      <button
                        type="button"
                        onClick={handleTourSendForClaimBtnClick}
                        className="inline-flex items-center justify-center gap-1.5 min-h-[2rem] px-3 py-1.5 text-xs font-semibold rounded-lg bg-blue-600 text-white hover:bg-blue-700"
                      >
                        <SendIcon className="w-3.5 h-3.5 shrink-0" />
                        <span>Send for Approval</span>
                      </button>
                    )}
                    {permissions.showEdit && (
                      <button
                        type="button"
                        onClick={() => navigate(`/travel/${id}/edit`)}
                        className="inline-flex items-center justify-center gap-1.5 min-h-[2rem] px-3 py-1.5 text-xs font-semibold rounded-lg bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors"
                      >
                        <PenSquareIcon className="w-3.5 h-3.5 shrink-0 stroke-[2.5px] text-gray-600" />
                        <span>Edit</span>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
        {/* PDF Viewer */}
        {pdfUrl && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
            <div className="relative w-[80%] h-[90%] bg-white rounded-2xl shadow-lg flex flex-col">
              {/* Action buttons top-right */}
              <div className="absolute top-3 right-3 flex items-center gap-2">
                {/* Exit button */}
                <div
                  onClick={() => setPdfUrl(null)}
                  className="flex cursor-pointer items-center justify-between gap-1 px-3 py-1 text-sm rounded bg-white text-gray-600 hover:bg-gray-100"
                >
                  <XIcon className="size-4 stroke-[2.5px]" />
                  <span>Exit</span>
                </div>

                {/* Download button */}
                <div className="flex items-center justify-between gap-1 px-3 py-1 text-sm rounded bg-white text-gray-600 hover:bg-gray-100">
                  <a
                    href={pdfUrl}
                    download={`travel-request-${
                      travelReqResponse.data?.data?.requestNo ||
                      travelReqResponse.data?.data?.tempRequestNo
                    }.pdf`}
                    className="flex items-center gap-2" // ✅ flex for icon + text
                  >
                    <DownloadIcon className="size-4 stroke-[2.5px]" />
                    <span>Download</span>
                  </a>
                </div>
              </div>

              {/* PDF iframe */}
              <iframe
                src={pdfUrl}
                title="Travel Request PDF"
                className="w-full h-full rounded-b-2xl"
              />
            </div>
          </div>
        )}
        {/* End of PDF Viewer */}

        <main className="travel-detail-canvas">
          {/* Display attachment recovery banner only if there are active failed or pending uploads */}
          {attachmentRecoveryResponse.data?.data?.readiness === 'PENDING' &&
            ((attachmentRecoveryResponse.data?.data?.counts?.failed ?? 0) > 0 ||
              (attachmentRecoveryResponse.data?.data?.counts?.pending ?? 0) >
                0) && (
              <Alert
                className="mx-3 mt-3"
                type="warning"
                showIcon
                message="Attachments Need Attention"
                description={
                  <div className="flex flex-wrap items-center justify-between gap-2">
                    <span>
                      This request is saved, but one or more attachments are
                      missing or failed. Files selected before a refresh must be
                      selected again.
                    </span>
                    <Button
                      size="small"
                      type="primary"
                      onClick={() =>
                        navigate(`/travel/${id}/edit?attachmentRecovery=true`)
                      }
                    >
                      Review Missing Attachments
                    </Button>
                  </div>
                }
              />
            )}
          <div className="travel-detail-canvas rounded-xl border border-slate-200/80 bg-white shadow-2xs overflow-hidden">
            <CardWizard addOnClass="travel-detail-header flex flex-col gap-2 py-2.5">
              {/* Header section with Heading and Buttons */}
              <div ref={headerRef} className="px-3 print:hidden">
                <div className="flex items-center justify-between gap-4 flex-wrap min-h-[2rem]">
                  <div className="flex items-center gap-3 flex-wrap min-w-0">
                    <button
                      type="button"
                      onClick={() => navigate(-1)}
                      className="p-1 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 shrink-0"
                      aria-label="Back"
                    >
                      <ArrowLeftIcon className="w-4 h-4" />
                    </button>
                    {/* <h1 className="text-lg font-bold text-gray-900 tracking-tight uppercase truncate">
                  Travel Request
                </h1> */}
                    {(travelReqResponse.data?.data?.requestNo ||
                      travelReqResponse.data?.data?.tempRequestNo) && (
                      <span className="inline-flex items-center text-lg font-bold text-gray-900 tracking-tight shrink-0">
                        {travelReqResponse.data?.data?.requestNo ||
                          travelReqResponse.data?.data?.tempRequestNo}
                      </span>
                    )}
                  </div>
                  <div className="flex items-center gap-1 sm:gap-2 flex-wrap justify-end ml-auto">
                    {travelReqResponse.data?.data?.submissionStatus ===
                    SubmissionStatus.SUBMITTED
                      ? renderApprovalStatusBadge(
                          travelReqResponse.data?.data,
                          lastActionApprover,
                        )
                      : null}
                    {canShowCancelButton &&
                      requestClaimType === ClaimRequestType.TRAVEL &&
                      travelReqResponse.data?.data?.submissionStatus ===
                        SubmissionStatus.SUBMITTED &&
                      !travelReqResponse.data?.data
                        ?.isRequestSubmittedForClaimApproval && (
                        <button
                          type="button"
                          onClick={handleCanceRequestClick}
                          className="inline-flex items-center justify-center gap-1.5 min-h-[2rem] px-3 py-1.5 text-xs font-semibold rounded-lg bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors"
                        >
                          <XMarkIcon className="w-3.5 h-3.5 shrink-0 stroke-[2.5px]" />
                          <span>Cancel</span>
                        </button>
                      )}
                    {travelReqResponse.data?.data?.hasAttachment && (
                      <button
                        type="button"
                        onClick={handleDownloadAttachments}
                        disabled={isDownloading}
                        className="inline-flex items-center justify-center gap-1.5 min-h-[2rem] px-3 py-1.5 text-xs font-semibold rounded-lg bg-white border border-slate-200/90 text-slate-700 hover:border-slate-300 hover:bg-slate-50 transition-all shadow-2xs disabled:opacity-50"
                      >
                        <Paperclip className="w-3.5 h-3.5 text-slate-500" />
                        <span>
                          {isDownloading ? 'Downloading...' : 'Attachments'}
                        </span>
                      </button>
                    )}
                    {travelReqResponse.data?.data?.submissionStatus ===
                      SubmissionStatus.SUBMITTED && (
                      <button
                        type="button"
                        onClick={handlePrint}
                        disabled={isPrinting}
                        className="inline-flex items-center justify-center gap-1.5 min-h-[2rem] px-3 py-1.5 text-xs font-semibold rounded-lg bg-white border border-slate-200/90 text-slate-700 hover:border-slate-300 hover:bg-slate-50 transition-all shadow-2xs disabled:opacity-50"
                      >
                        <Printer className="w-3.5 h-3.5 text-slate-500" />
                        <span>{isPrinting ? 'Generating...' : 'Print'}</span>
                      </button>
                    )}
                    {travelReqResponse.data?.data?.submissionStatus ===
                      SubmissionStatus.SUBMITTED && (
                      <button
                        type="button"
                        onClick={handleApprovalHierarchyClick}
                        className="inline-flex items-center justify-center gap-1.5 min-h-[2rem] px-3 py-1.5 text-xs font-semibold rounded-lg bg-white border border-slate-200/90 text-slate-700 hover:border-slate-300 hover:bg-slate-50 transition-all shadow-2xs"
                      >
                        <Network className="w-3.5 h-3.5 text-slate-500" />
                        <span>Hierarchy</span>
                      </button>
                    )}
                    {travelReqResponse.data?.data?.submissionStatus ===
                      SubmissionStatus.SUBMITTED && (
                      <Dropdown
                        menu={{
                          items: VIEW_MENU_OPTIONS,
                          onClick: ({ key }) => {
                            if (key === 'approvalLog') {
                              setIsLogOpen(true);
                              setPagination(prev => ({ ...prev, page: 1 }));
                            } else if (key === 'changeLog') {
                              setIsChangelogOpen(true);
                              setPagination(prev => ({ ...prev, page: 1 }));
                            } else if (key === 'sapLog') {
                              setIsSapLogOpen(true);
                              setSapLogFilters(prev => ({ ...prev, page: 1 }));
                            }
                          },
                        }}
                        trigger={['click']}
                      >
                        <button
                          type="button"
                          className="inline-flex items-center justify-center gap-1.5 min-h-[2rem] px-3 py-1.5 text-xs font-semibold rounded-lg bg-white border border-slate-200/90 text-slate-700 hover:border-slate-300 hover:bg-slate-50 transition-all shadow-2xs"
                        >
                          <Logs className="w-3.5 h-3.5 text-slate-500" />
                          <span>Logs</span>
                          <ArrowDown className="w-3 h-3 text-slate-400" />
                        </button>
                      </Dropdown>
                    )}
                    {permissions.showApprovalAction &&
                      (travelReqResponse.data?.data?.approvalStatus ===
                        SystemApprovalStatus.IN_REVIEW &&
                      travelReqResponse.data?.data?.currentApprovalLevel ===
                        null &&
                      travelReqResponse.data?.data?.employee == user?.ID ? (
                        <button
                          type="button"
                          onClick={() =>
                            handleApprovalAction(SystemApprovalAction.APPROVE)
                          }
                          className="inline-flex items-center justify-center gap-1.5 min-h-[2rem] px-3 py-1.5 text-xs font-semibold rounded-lg bg-blue-600 text-white hover:bg-blue-700"
                        >
                          <CheckBadgeIcon className="w-3.5 h-3.5 shrink-0" />
                          <span>Send for Approval</span>
                        </button>
                      ) : (
                        <Dropdown
                          menu={{
                            items: parsedApprovalActionMenuOptions,
                            onClick: ({ key }) => {
                              handleApprovalAction(
                                key as unknown as SystemApprovalAction,
                              );
                            },
                          }}
                          trigger={['click']}
                        >
                          <button
                            type="button"
                            className="inline-flex items-center justify-center gap-1.5 min-h-[2rem] px-3 py-1.5 text-xs font-semibold rounded-lg bg-gray-800 text-white hover:bg-gray-900"
                          >
                            <span>Take Action</span>
                            <ArrowDown className="w-3 h-3 shrink-0" />
                          </button>
                        </Dropdown>
                      ))}
                    {permissions.showSendTourForClaim && (
                      <button
                        type="button"
                        onClick={handleTourSendForClaimBtnClick}
                        className="inline-flex items-center justify-center gap-1.5 min-h-[2rem] px-3 py-1.5 text-xs font-semibold rounded-lg bg-blue-600 text-white hover:bg-blue-700"
                      >
                        <SendIcon className="w-3.5 h-3.5 shrink-0" />
                        <span>Send for Approval</span>
                      </button>
                    )}
                    {permissions.showEdit && (
                      <button
                        type="button"
                        onClick={() => navigate(`/travel/${id}/edit`)}
                        className="inline-flex items-center justify-center gap-1.5 min-h-[2rem] px-3 py-1.5 text-xs font-semibold rounded-lg bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors"
                      >
                        <PenSquareIcon className="w-3.5 h-3.5 shrink-0 stroke-[2.5px] text-gray-600" />
                        <span>Edit</span>
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <hr className="border-t border-gray-200" />

              <div className="travel-detail-summary-grid grid grid-cols-1 px-3 md:grid-cols-3">
                {/* Employee Data */}
                <div className="travel-detail-summary-section">
                  <HeadingWizard>
                    <h2 className="mb-3 text-base font-semibold text-[#202022]">
                      Employee Details
                    </h2>
                  </HeadingWizard>
                  {(() => {
                    const forEmployee =
                      travelReqResponse.data?.data?.forEmployee;
                    return (
                      <div className="travel-detail-data-grid grid w-full grid-cols-2">
                        <GridDataPoint
                          config={{
                            label: 'Full Name',
                            value: forEmployee?.FullName || '-',
                          }}
                        />
                        <GridDataPoint
                          config={{
                            label: 'Employee Code',
                            value: forEmployee?.EmployeeCode || '-',
                          }}
                        />
                        <GridDataPoint
                          config={{
                            label: 'Department',
                            value: forEmployee?.department?.name || '-',
                          }}
                        />
                        <GridDataPoint
                          config={{
                            label: 'Designation',
                            value: forEmployee?.designation?.name || '-',
                          }}
                        />
                        <GridDataPoint
                          config={{
                            label: 'Cost Center',
                            value: forEmployee?.costCenter?.name || '-',
                          }}
                        />
                        <GridDataPoint
                          config={{
                            label: 'Email ID',
                            value: (
                              <div className="w-[150px] truncate">
                                <Tooltip title={forEmployee?.EmailID || '-'}>
                                  {forEmployee?.EmailID || '-'}
                                </Tooltip>
                              </div>
                            ),
                          }}
                        />
                        <GridDataPoint
                          config={{
                            label: 'Grade',
                            value: forEmployee?.grade?.name || '-',
                          }}
                        />
                        <GridDataPoint
                          config={{
                            label: 'Company',
                            value: forEmployee?.company
                              ? `${forEmployee.company.ShortDescription || ''} - ${forEmployee.company.LongDescription || ''}`
                              : '-',
                          }}
                        />
                      </div>
                    );
                  })()}
                </div>

                {/* Approval Details */}
                <div className="travel-detail-summary-section">
                  <HeadingWizard>
                    <div className="flex items-center justify-between gap-3">
                      <h2 className="text-base font-semibold text-[#202022]">
                        Approval Details
                      </h2>
                    </div>
                  </HeadingWizard>
                  <div className="travel-detail-data-grid grid w-full grid-cols-2">
                    <GridDataPoint
                      config={{
                        label: 'Approval Status',
                        value: auditData?.approvalStatus,
                      }}
                    />
                    <GridDataPoint
                      config={{
                        label: 'Current Approver',
                        value: auditData?.approver,
                      }}
                    />
                    <GridDataPoint
                      config={{
                        label: 'Claim Final Approved',
                        value: auditData?.isClaimFinalApproved,
                      }}
                    />
                    <GridDataPoint
                      config={{
                        label: 'Claim Final Approved At',
                        value: auditData?.claimFinalApprovedTimeStamp,
                      }}
                    />
                    <GridDataPoint
                      config={{
                        label: 'Claim Final Approved By',
                        value: auditData?.finalApprovedBy,
                      }}
                    />
                    {travelReqResponse.data?.data?.isClaimFinalApproved && (
                      <>
                        <GridDataPoint
                          config={{
                            label: 'Payment Status',
                            value: auditData?.markAsPaid,
                          }}
                        />
                      </>
                    )}

                    {requestClaimType === ClaimRequestType.TRAVEL && (
                      <>
                        <GridDataPoint
                          config={{
                            label: 'Tour Approved',
                            value: auditData?.isRequestFinalApproved,
                          }}
                        />
                        <GridDataPoint
                          config={{
                            label: 'Tour Approved At',
                            value: auditData?.requestFinalApprovedTimeStamp,
                          }}
                        />
                        <GridDataPoint
                          config={{
                            label: 'Tour Approved By',
                            value: auditData?.requestFinalApprover,
                          }}
                        />
                      </>
                    )}
                  </div>
                </div>

                {/*Transaction Details */}
                <div className="travel-detail-summary-section">
                  <HeadingWizard>
                    <div className="flex items-center justify-between gap-3">
                      <h2 className="text-base font-semibold text-[#202022]">
                        Transaction Details
                      </h2>
                      {/* <ButtonWizard
                    addOnClass="bg-white px-3 py-1.5 hover:underline text-[#4649EC]"
                    addOnTextClass="text-[#4649EC] hover:text-primary-500"
                    buttonText="View More"
                    onBtnClick={() => setIsTransactionDetailsSheetOpen(true)}
                  > */}
                      <button
                        onClick={() => setIsTransactionDetailsSheetOpen(true)}
                        className="group p-1 flex items-start justify-center rounded-full bg-primary-700/20 hover:bg-primary-700/40 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500"
                        aria-label="View Transaction Details"
                        title="View Transaction Details"
                      >
                        <ChevronRight className="size-4 stroke-[2px] text-[#4649EC] group-hover:text-primary-500 transition-colors duration-200" />
                      </button>

                      {/* </ButtonWizard> */}
                    </div>
                  </HeadingWizard>
                  <div className="travel-detail-data-grid grid w-full grid-cols-2">
                    <GridDataPoint
                      config={{
                        label: 'Claim Category',
                        value: auditData?.claimCategory,
                      }}
                    />
                    <GridDataPoint
                      config={{
                        label: 'Claim Subcategory',
                        value: auditData?.claimSubCategory,
                      }}
                    />
                    <GridDataPoint
                      config={{
                        label: 'Claim Amount',
                        value: auditData?.totalAmount,
                      }}
                    />
                    {(isAdminTypeRole(user) ||
                      travelReqResponse.data?.data?.isClaimFinalApproved) && (
                      <GridDataPoint
                        config={{
                          label: 'Approved Amount',
                          value: auditData?.approvedAmount,
                        }}
                      />
                    )}
                    <GridDataPoint
                      config={{
                        label: 'Created By',
                        value: auditData?.createdByUser,
                      }}
                    />
                    <GridDataPoint
                      config={{
                        label: 'Updated By',
                        value: auditData?.updatedByUser,
                      }}
                    />
                    {formConfig?.header?.fields?.customer?.visible ? (
                      <GridDataPoint
                        config={{
                          label: formConfig?.header?.fields?.customer?.label,
                          value: header?.customer,
                        }}
                      />
                    ) : null}
                    <GridDataPoint
                      config={{
                        label: 'Submitted On',
                        value: auditData?.submittedOn,
                      }}
                    />
                    {formConfig?.header?.fields?.remarks?.visible ? (
                      <>
                        <GridDataPoint
                          config={{
                            label: formConfig?.header?.fields?.remarks?.label,
                            value: header?.remarks,
                          }}
                        />
                      </>
                    ) : (
                      <></>
                    )}
                    {/* <GridDataPoint
                  config={{
                    label: 'Created By',
                    value: auditData?.createdByUser,
                  }}
                />
                <GridDataPoint
                  config={{
                    label: 'Claim Month',
                    value: formatClaimMonthYear(
                      auditData?.claimMonth,
                      auditData?.claimYear,
                    ),
                  }}
                />
                <GridDataPoint
                  config={{
                    label: 'Created At',
                    value: auditData?.createdAt,
                  }}
                />

                <GridDataPoint
                  config={{
                    label: 'Updated At',
                    value: auditData?.updatedAt,
                  }}
                />
                <GridDataPoint
                  config={{
                    label: 'Updated By',
                    value: auditData?.updatedByUser,
                  }}
                />
                {formConfig?.header?.fields?.cost?.visible ? (
                  <>
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.cost?.label,
                        value: header?.cost,
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}
                {formConfig?.header?.fields?.advanceAmount?.visible ||
                formConfig?.header?.fields?.advanceAmountCurrency?.visible ? (
                  <>
                    <div className="flex items-end gap-x-0.5">
                      <div className="flex-1">
                        {formConfig?.header?.fields?.advanceAmount?.visible ? (
                          <>
                            <GridDataPoint
                              config={{
                                label:
                                  formConfig?.header?.fields?.advanceAmount
                                    ?.label,
                                value: header?.advanceAmount,
                              }}
                            />
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}

                {formConfig?.header?.fields?.handsetModel?.visible ? (
                  <>
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.handsetModel?.label,
                        value: header?.handsetModel,
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}

                {formConfig?.header?.fields?.dateOfPurchase?.visible ? (
                  <>
                    <GridDataPoint
                      config={{
                        label:
                          formConfig?.header?.fields?.dateOfPurchase?.label,
                        value: header?.dateOfPurchase,
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}

                {formConfig?.header?.fields?.imeiNo?.visible ? (
                  <>
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.imeiNo?.label,
                        value: header?.imeiNo,
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}
                {formConfig?.header?.fields?.startDate?.visible ? (
                  <>
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.startDate?.label,
                        value: header?.startDate,
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}

                {formConfig?.header?.fields?.endDate?.visible ? (
                  <>
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.endDate?.label,
                        value: header?.endDate,
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}

                {formConfig?.header?.fields?.costCenter?.visible ? (
                  <>
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.costCenter?.label,
                        value: header?.costCenter,
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}

                {formConfig?.header?.fields?.fromCountry?.visible ? (
                  <>
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.fromCountry?.label,
                        value: header?.fromCountry,
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}

                {formConfig?.header?.fields?.fromCity?.visible ? (
                  <>
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.fromCity?.label,
                        value: header?.fromCity,
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}

                {formConfig?.header?.fields?.toCountry?.visible ? (
                  <>
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.toCountry?.label,
                        value: header?.toCountry,
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}

                {formConfig?.header?.fields?.toCity?.visible ? (
                  <>
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.toCity?.label,
                        value: header?.toCity,
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}

                {formConfig?.header?.fields?.budgetCurrency?.visible ||
                formConfig?.header?.fields?.budget?.visible ? (
                  <>
                    <div className="flex items-end gap-x-0.5">
                      <div className="flex-1">
                        {formConfig?.header?.fields?.budget?.visible ? (
                          <>
                            <GridDataPoint
                              config={{
                                label:
                                  formConfig?.header?.fields?.budget?.label,
                                value: header?.budget,
                              }}
                            />
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}
                {travelReqResponse?.data?.data?.approvalStatus ===
                SystemApprovalStatus.CANCELLED ? (
                  <>
                    <GridDataPoint
                      config={{
                        label: 'Cancellation Reason',
                        value:
                          travelReqResponse?.data?.data?.cancellationRemarks ||
                          '-',
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}
                {formConfig?.header?.fields?.purposeOfTravel?.visible ? (
                  <>
                    <GridDataPoint
                      config={{
                        label:
                          formConfig?.header?.fields?.purposeOfTravel?.label,
                        value: header?.purposeOfTravel,
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}

                {formConfig?.header?.fields?.billToCustomer?.visible ? (
                  <>
                    <GridDataPoint
                      config={{
                        label:
                          formConfig?.header?.fields?.billToCustomer?.label,
                        value: header?.billToCustomer,
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}
                {formConfig?.header?.fields?.customer?.visible ? (
                  <>
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.customer?.label,
                        value: header?.customer,
                      }}
                    />
                  </>
                ) : (
                  <></>
                )} */}
                  </div>
                </div>
              </div>
            </CardWizard>
            {/* End of header section */}

            {/* Don't show a line item section if its data is not available */}

            <section
              className="travel-line-items-workspace flex flex-col gap-1.5"
              aria-label="Travel Line Items"
            >
              {/* Start of mode of journey section */}
              {journeyData?.length > 0 && (
                <CardWizard addOnClass="flex flex-col gap-1 p-4 px-0 py-0">
                  <div
                    {...getLineItemAccordionTriggerProps(
                      Boolean(
                        lineItemAccordionConfig[
                          TravelRequestLineItemSection.MODE_OF_JOURNEY
                        ],
                      ),
                    )}
                    className="flex cursor-pointer items-center justify-between px-3 py-2 transition-colors hover:bg-slate-50/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#8B86F7]"
                    onClick={e => {
                      e.stopPropagation();
                      handleLineItemAccordionClick(
                        TravelRequestLineItemSection.MODE_OF_JOURNEY,
                      );
                    }}
                  >
                    <LineItemHeaderTitle count={journeyData?.length}>
                      {
                        TRAVEL_REQUEST_LINE_ITEM_SECTION_LABEL_MAP[
                          TravelRequestLineItemSection.MODE_OF_JOURNEY
                        ]
                      }
                    </LineItemHeaderTitle>
                    <div className="flex items-center gap-2">
                      <Dropdown
                        menu={{
                          items: [
                            { key: 'default', label: 'Default Order' },
                            { type: 'divider' },
                            { key: 'date_desc', label: 'Date (Newest First)' },
                            { key: 'date_asc', label: 'Date (Oldest First)' },
                          ],
                          onClick: event =>
                            handleLineItemSortMenuClick(event, key =>
                              handleSortChange(
                                TravelRequestLineItemSection.MODE_OF_JOURNEY,
                                key,
                              ),
                            ),
                          selectedKeys: [
                            tableSortState[
                              TravelRequestLineItemSection.MODE_OF_JOURNEY
                            ]?.key || 'default',
                          ],
                        }}
                        trigger={['click']}
                      >
                        <button
                          type="button"
                          aria-label="Sort options"
                          className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 text-xs font-semibold shadow-2xs transition-all ${
                            tableSortState[
                              TravelRequestLineItemSection.MODE_OF_JOURNEY
                            ]
                              ? 'border-indigo-300 bg-indigo-50 text-indigo-700 ring-2 ring-indigo-100'
                              : 'border-slate-200/80 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900'
                          }`}
                          onClick={e => e.stopPropagation()}
                        >
                          <ArrowUpDown className="size-3.5 text-slate-500" />
                          <span>Sort</span>
                        </button>
                      </Dropdown>
                      <button
                        type="button"
                        aria-label="Filter Columns"
                        className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 text-xs font-semibold shadow-2xs transition-all ${
                          tableFilterState[
                            TravelRequestLineItemSection.MODE_OF_JOURNEY
                          ]
                            ? 'border-indigo-300 bg-indigo-50 text-indigo-700 ring-2 ring-indigo-100'
                            : 'border-slate-200/80 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900'
                        }`}
                        onClick={e => {
                          e.stopPropagation();
                          toggleSectionFilter(
                            TravelRequestLineItemSection.MODE_OF_JOURNEY,
                          );
                        }}
                      >
                        <Filter className="size-3.5 text-slate-500" />
                        <span>Filter Columns</span>
                      </button>
                      <ButtonWizard
                        addOnClass="shadow-none px-2 py-1"
                        buttonText=""
                        onBtnClick={e => {
                          e.stopPropagation();
                          setLineItemAccordionConfig(prev => ({
                            ...prev,
                            [TravelRequestLineItemSection.MODE_OF_JOURNEY]:
                              !prev[
                                TravelRequestLineItemSection.MODE_OF_JOURNEY
                              ],
                          }));
                        }}
                      >
                        <LineItemAccordionToggleButton
                          isOpen={
                            lineItemAccordionConfig[
                              TravelRequestLineItemSection.MODE_OF_JOURNEY
                            ]
                          }
                        />
                      </ButtonWizard>
                    </div>
                  </div>
                  <AnimatePresence initial={false}>
                    {lineItemAccordionConfig[
                      TravelRequestLineItemSection.MODE_OF_JOURNEY
                    ] && (
                      <LineItemAccordionLineItemContent
                        type={TravelRequestLineItemSection.MODE_OF_JOURNEY}
                      >
                        <LineItemTable
                          table={modeOfJourneyTable}
                          showFilters={Boolean(
                            tableFilterState[
                              TravelRequestLineItemSection.MODE_OF_JOURNEY
                            ],
                          )}
                          activeSort={
                            tableSortState[
                              TravelRequestLineItemSection.MODE_OF_JOURNEY
                            ]
                          }
                        />
                      </LineItemAccordionLineItemContent>
                    )}
                  </AnimatePresence>
                </CardWizard>
              )}
              {/* End of mode of journey section */}

              {/* Start of accommodation type section */}
              {accommodationData?.length > 0 && (
                <CardWizard addOnClass="flex flex-col gap-1 p-4 px-0 py-0">
                  <div
                    {...getLineItemAccordionTriggerProps(
                      Boolean(
                        lineItemAccordionConfig[
                          TravelRequestLineItemSection.ACCOMMODATION_TYPE
                        ],
                      ),
                    )}
                    className="flex cursor-pointer items-center justify-between px-3 py-2 transition-colors hover:bg-slate-50/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#8B86F7]"
                    onClick={e => {
                      e.stopPropagation();
                      handleLineItemAccordionClick(
                        TravelRequestLineItemSection.ACCOMMODATION_TYPE,
                      );
                    }}
                  >
                    <LineItemHeaderTitle count={accommodationData?.length}>
                      {
                        TRAVEL_REQUEST_LINE_ITEM_SECTION_LABEL_MAP[
                          TravelRequestLineItemSection.ACCOMMODATION_TYPE
                        ]
                      }
                    </LineItemHeaderTitle>
                    <div className="flex items-center gap-2">
                      <Dropdown
                        menu={{
                          items: [
                            { key: 'default', label: 'Default Order' },
                            { type: 'divider' },
                            { key: 'date_desc', label: 'Date (Newest First)' },
                            { key: 'date_asc', label: 'Date (Oldest First)' },
                          ],
                          onClick: event =>
                            handleLineItemSortMenuClick(event, key =>
                              handleSortChange(
                                TravelRequestLineItemSection.ACCOMMODATION_TYPE,
                                key,
                              ),
                            ),
                          selectedKeys: [
                            tableSortState[
                              TravelRequestLineItemSection.ACCOMMODATION_TYPE
                            ]?.key || 'default',
                          ],
                        }}
                        trigger={['click']}
                      >
                        <button
                          type="button"
                          aria-label="Sort options"
                          className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 text-xs font-semibold shadow-2xs transition-all ${
                            tableSortState[
                              TravelRequestLineItemSection.ACCOMMODATION_TYPE
                            ]
                              ? 'border-indigo-300 bg-indigo-50 text-indigo-700 ring-2 ring-indigo-100'
                              : 'border-slate-200/80 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900'
                          }`}
                          onClick={e => e.stopPropagation()}
                        >
                          <ArrowUpDown className="size-3.5 text-slate-500" />
                          <span>Sort</span>
                        </button>
                      </Dropdown>
                      <button
                        type="button"
                        aria-label="Filter Columns"
                        className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 text-xs font-semibold shadow-2xs transition-all ${
                          tableFilterState[
                            TravelRequestLineItemSection.ACCOMMODATION_TYPE
                          ]
                            ? 'border-indigo-300 bg-indigo-50 text-indigo-700 ring-2 ring-indigo-100'
                            : 'border-slate-200/80 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900'
                        }`}
                        onClick={e => {
                          e.stopPropagation();
                          toggleSectionFilter(
                            TravelRequestLineItemSection.ACCOMMODATION_TYPE,
                          );
                        }}
                      >
                        <Filter className="size-3.5 text-slate-500" />
                        <span>Filter Columns</span>
                      </button>
                      <ButtonWizard
                        addOnClass="shadow-none px-2 py-1"
                        buttonText=""
                        onBtnClick={e => {
                          e.stopPropagation();
                          setLineItemAccordionConfig(prev => ({
                            ...prev,
                            [TravelRequestLineItemSection.ACCOMMODATION_TYPE]:
                              !prev[
                                TravelRequestLineItemSection.ACCOMMODATION_TYPE
                              ],
                          }));
                        }}
                      >
                        <LineItemAccordionToggleButton
                          isOpen={
                            lineItemAccordionConfig[
                              TravelRequestLineItemSection.ACCOMMODATION_TYPE
                            ]
                          }
                        />
                      </ButtonWizard>
                    </div>
                  </div>
                  <AnimatePresence initial={false}>
                    {lineItemAccordionConfig[
                      TravelRequestLineItemSection.ACCOMMODATION_TYPE
                    ] && (
                      <LineItemAccordionLineItemContent
                        type={TravelRequestLineItemSection.ACCOMMODATION_TYPE}
                      >
                        <LineItemTable
                          table={accommodationTable}
                          showFilters={Boolean(
                            tableFilterState[
                              TravelRequestLineItemSection.ACCOMMODATION_TYPE
                            ],
                          )}
                          activeSort={
                            tableSortState[
                              TravelRequestLineItemSection.ACCOMMODATION_TYPE
                            ]
                          }
                        />
                      </LineItemAccordionLineItemContent>
                    )}
                  </AnimatePresence>
                </CardWizard>
              )}
              {/* End of accommodation type section */}

              {/* Start of expense claim section */}
              {expenseClaimData?.length > 0 && (
                <CardWizard addOnClass="flex flex-col gap-1 p-4 px-0 py-0">
                  <div
                    {...getLineItemAccordionTriggerProps(
                      Boolean(
                        lineItemAccordionConfig[
                          TravelRequestLineItemSection.EXPENSE_CLAIM
                        ],
                      ),
                    )}
                    className="flex cursor-pointer items-center justify-between px-3 py-2 transition-colors hover:bg-slate-50/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#8B86F7]"
                    onClick={e => {
                      e.stopPropagation();
                      handleLineItemAccordionClick(
                        TravelRequestLineItemSection.EXPENSE_CLAIM,
                      );
                    }}
                  >
                    <LineItemHeaderTitle count={expenseClaimData?.length}>
                      {
                        TRAVEL_REQUEST_LINE_ITEM_SECTION_LABEL_MAP[
                          TravelRequestLineItemSection.EXPENSE_CLAIM
                        ]
                      }
                    </LineItemHeaderTitle>
                    <div className="flex items-center gap-2">
                      <Dropdown
                        menu={{
                          items: [
                            { key: 'default', label: 'Default Order' },
                            { type: 'divider' },
                            { key: 'date_desc', label: 'Date (Newest First)' },
                            { key: 'date_asc', label: 'Date (Oldest First)' },
                            {
                              key: 'amount_desc',
                              label: 'Amount (High to Low)',
                            },
                            {
                              key: 'amount_asc',
                              label: 'Amount (Low to High)',
                            },
                          ],
                          onClick: event =>
                            handleLineItemSortMenuClick(event, key =>
                              handleSortChange(
                                TravelRequestLineItemSection.EXPENSE_CLAIM,
                                key,
                              ),
                            ),
                          selectedKeys: [
                            tableSortState[
                              TravelRequestLineItemSection.EXPENSE_CLAIM
                            ]?.key || 'default',
                          ],
                        }}
                        trigger={['click']}
                      >
                        <button
                          type="button"
                          aria-label="Sort options"
                          className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 text-xs font-semibold shadow-2xs transition-all ${
                            tableSortState[
                              TravelRequestLineItemSection.EXPENSE_CLAIM
                            ]
                              ? 'border-indigo-300 bg-indigo-50 text-indigo-700 ring-2 ring-indigo-100'
                              : 'border-slate-200/80 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900'
                          }`}
                          onClick={e => e.stopPropagation()}
                        >
                          <ArrowUpDown className="size-3.5 text-slate-500" />
                          <span>Sort</span>
                        </button>
                      </Dropdown>
                      <button
                        type="button"
                        aria-label="Filter Columns"
                        className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 text-xs font-semibold shadow-2xs transition-all ${
                          tableFilterState[
                            TravelRequestLineItemSection.EXPENSE_CLAIM
                          ]
                            ? 'border-indigo-300 bg-indigo-50 text-indigo-700 ring-2 ring-indigo-100'
                            : 'border-slate-200/80 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900'
                        }`}
                        onClick={e => {
                          e.stopPropagation();
                          toggleSectionFilter(
                            TravelRequestLineItemSection.EXPENSE_CLAIM,
                          );
                        }}
                      >
                        <Filter className="size-3.5 text-slate-500" />
                        <span>Filter Columns</span>
                      </button>
                      <ButtonWizard
                        addOnClass="shadow-none px-2 py-1"
                        buttonText=""
                        onBtnClick={e => {
                          e.stopPropagation();
                          setLineItemAccordionConfig(prev => ({
                            ...prev,
                            [TravelRequestLineItemSection.EXPENSE_CLAIM]:
                              !prev[TravelRequestLineItemSection.EXPENSE_CLAIM],
                          }));
                        }}
                      >
                        <LineItemAccordionToggleButton
                          isOpen={
                            lineItemAccordionConfig[
                              TravelRequestLineItemSection.EXPENSE_CLAIM
                            ]
                          }
                        />
                      </ButtonWizard>
                    </div>
                  </div>
                  <AnimatePresence initial={false}>
                    {lineItemAccordionConfig[
                      TravelRequestLineItemSection.EXPENSE_CLAIM
                    ] && (
                      <LineItemAccordionLineItemContent
                        type={TravelRequestLineItemSection.EXPENSE_CLAIM}
                      >
                        <LineItemTable
                          table={expenseClaimTable}
                          showFilters={Boolean(
                            tableFilterState[
                              TravelRequestLineItemSection.EXPENSE_CLAIM
                            ],
                          )}
                          activeSort={
                            tableSortState[
                              TravelRequestLineItemSection.EXPENSE_CLAIM
                            ]
                          }
                        />
                        {expenseClaimData && expenseClaimData.length > 0 && (
                          <div className="line-item-section-total">
                            <div className="flex items-baseline gap-x-2 text-slate-700">
                              <span className="text-xs font-bold tracking-tight text-slate-600">
                                Total Amount:
                              </span>
                              <span className="text-sm font-extrabold text-[#3C4F76]">
                                {totalExpenseClaimAmount !== null &&
                                totalExpenseClaimAmount !== undefined
                                  ? getFormattedAmount(totalExpenseClaimAmount)
                                  : '-'}
                              </span>
                            </div>
                          </div>
                        )}
                      </LineItemAccordionLineItemContent>
                    )}
                  </AnimatePresence>
                </CardWizard>
              )}
              {/* End of expense claim section */}

              {/* Start of office expense claim section */}
              {officeExpenseClaimData?.length > 0 && (
                <CardWizard addOnClass="flex flex-col gap-1 p-4 px-0 py-0">
                  <div
                    {...getLineItemAccordionTriggerProps(
                      Boolean(
                        lineItemAccordionConfig[
                          TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM
                        ],
                      ),
                    )}
                    className="flex cursor-pointer items-center justify-between px-3 py-2 transition-colors hover:bg-slate-50/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#8B86F7]"
                    onClick={e => {
                      e.stopPropagation();
                      handleLineItemAccordionClick(
                        TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM,
                      );
                    }}
                  >
                    <LineItemHeaderTitle count={officeExpenseClaimData?.length}>
                      {
                        TRAVEL_REQUEST_LINE_ITEM_SECTION_LABEL_MAP[
                          TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM
                        ]
                      }
                    </LineItemHeaderTitle>
                    <div className="flex items-center gap-2">
                      <Dropdown
                        menu={{
                          items: [
                            { key: 'default', label: 'Default Order' },
                            { type: 'divider' },
                            { key: 'date_desc', label: 'Date (Newest First)' },
                            { key: 'date_asc', label: 'Date (Oldest First)' },
                            {
                              key: 'amount_desc',
                              label: 'Amount (High to Low)',
                            },
                            {
                              key: 'amount_asc',
                              label: 'Amount (Low to High)',
                            },
                          ],
                          onClick: event =>
                            handleLineItemSortMenuClick(event, key =>
                              handleSortChange(
                                TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM,
                                key,
                              ),
                            ),
                          selectedKeys: [
                            tableSortState[
                              TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM
                            ]?.key || 'default',
                          ],
                        }}
                        trigger={['click']}
                      >
                        <button
                          type="button"
                          aria-label="Sort options"
                          className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 text-xs font-semibold shadow-2xs transition-all ${
                            tableSortState[
                              TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM
                            ]
                              ? 'border-indigo-300 bg-indigo-50 text-indigo-700 ring-2 ring-indigo-100'
                              : 'border-slate-200/80 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900'
                          }`}
                          onClick={e => e.stopPropagation()}
                        >
                          <ArrowUpDown className="size-3.5 text-slate-500" />
                          <span>Sort</span>
                        </button>
                      </Dropdown>
                      <button
                        type="button"
                        aria-label="Filter Columns"
                        className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 text-xs font-semibold shadow-2xs transition-all ${
                          tableFilterState[
                            TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM
                          ]
                            ? 'border-indigo-300 bg-indigo-50 text-indigo-700 ring-2 ring-indigo-100'
                            : 'border-slate-200/80 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900'
                        }`}
                        onClick={e => {
                          e.stopPropagation();
                          toggleSectionFilter(
                            TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM,
                          );
                        }}
                      >
                        <Filter className="size-3.5 text-slate-500" />
                        <span>Filter Columns</span>
                      </button>
                      <ButtonWizard
                        addOnClass="shadow-none px-2 py-1"
                        buttonText=""
                        onBtnClick={e => {
                          e.stopPropagation();
                          setLineItemAccordionConfig(prev => ({
                            ...prev,
                            [TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM]:
                              !prev[
                                TravelRequestLineItemSection
                                  .OFFICE_EXPENSE_CLAIM
                              ],
                          }));
                        }}
                      >
                        <LineItemAccordionToggleButton
                          isOpen={
                            lineItemAccordionConfig[
                              TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM
                            ]
                          }
                        />
                      </ButtonWizard>
                    </div>
                  </div>
                  <AnimatePresence initial={false}>
                    {lineItemAccordionConfig[
                      TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM
                    ] && (
                      <LineItemAccordionLineItemContent
                        type={TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM}
                      >
                        <LineItemTable
                          table={officeExpenseClaimTable}
                          showFilters={Boolean(
                            tableFilterState[
                              TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM
                            ],
                          )}
                          activeSort={
                            tableSortState[
                              TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM
                            ]
                          }
                        />
                        {officeExpenseClaimData &&
                          officeExpenseClaimData.length > 0 && (
                            <div className="line-item-section-total">
                              <div className="flex items-baseline gap-x-2 text-slate-700">
                                <span className="text-xs font-bold tracking-tight text-slate-600">
                                  Total Amount:
                                </span>
                                <span className="text-sm font-extrabold text-[#3C4F76]">
                                  {officeExpenseClaimData.reduce(
                                    (total, item) => {
                                      const amount = item.amount
                                        ? Number(item.amount)
                                        : 0;
                                      return total + amount;
                                    },
                                    0,
                                  ) !== null &&
                                  officeExpenseClaimData.reduce(
                                    (total, item) => {
                                      const amount = item.amount
                                        ? Number(item.amount)
                                        : 0;
                                      return total + amount;
                                    },
                                    0,
                                  ) !== undefined
                                    ? getFormattedAmount(
                                        officeExpenseClaimData.reduce(
                                          (total, item) => {
                                            const amount = item.amount
                                              ? Number(item.amount)
                                              : 0;
                                            return total + amount;
                                          },
                                          0,
                                        ),
                                      )
                                    : '-'}
                                </span>
                              </div>
                            </div>
                          )}
                      </LineItemAccordionLineItemContent>
                    )}
                  </AnimatePresence>
                </CardWizard>
              )}
              {/* End of office expense claim section */}

              {/* Start of per diem section */}
              {perDiemData?.length > 0 && (
                <CardWizard addOnClass="flex flex-col gap-1 p-4 px-0 py-0">
                  <div
                    {...getLineItemAccordionTriggerProps(
                      Boolean(
                        lineItemAccordionConfig[
                          TravelRequestLineItemSection.PER_DIEM
                        ],
                      ),
                    )}
                    className="flex cursor-pointer items-center justify-between px-3 py-2 transition-colors hover:bg-slate-50/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#8B86F7]"
                    onClick={e => {
                      e.stopPropagation();
                      handleLineItemAccordionClick(
                        TravelRequestLineItemSection.PER_DIEM,
                      );
                    }}
                  >
                    <LineItemHeaderTitle count={perDiemData?.length}>
                      {
                        TRAVEL_REQUEST_LINE_ITEM_SECTION_LABEL_MAP[
                          TravelRequestLineItemSection.PER_DIEM
                        ]
                      }
                    </LineItemHeaderTitle>
                    <div className="flex items-center gap-2">
                      <Dropdown
                        menu={{
                          items: [
                            { key: 'default', label: 'Default Order' },
                            { type: 'divider' },
                            { key: 'date_desc', label: 'Date (Newest First)' },
                            { key: 'date_asc', label: 'Date (Oldest First)' },
                          ],
                          onClick: event =>
                            handleLineItemSortMenuClick(event, key =>
                              handleSortChange(
                                TravelRequestLineItemSection.PER_DIEM,
                                key,
                              ),
                            ),
                          selectedKeys: [
                            tableSortState[
                              TravelRequestLineItemSection.PER_DIEM
                            ]?.key || 'default',
                          ],
                        }}
                        trigger={['click']}
                      >
                        <button
                          type="button"
                          aria-label="Sort options"
                          className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 text-xs font-semibold shadow-2xs transition-all ${
                            tableSortState[
                              TravelRequestLineItemSection.PER_DIEM
                            ]
                              ? 'border-indigo-300 bg-indigo-50 text-indigo-700 ring-2 ring-indigo-100'
                              : 'border-slate-200/80 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900'
                          }`}
                          onClick={e => e.stopPropagation()}
                        >
                          <ArrowUpDown className="size-3.5 text-slate-500" />
                          <span>Sort</span>
                        </button>
                      </Dropdown>
                      <button
                        type="button"
                        aria-label="Filter Columns"
                        className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 text-xs font-semibold shadow-2xs transition-all ${
                          tableFilterState[
                            TravelRequestLineItemSection.PER_DIEM
                          ]
                            ? 'border-indigo-300 bg-indigo-50 text-indigo-700 ring-2 ring-indigo-100'
                            : 'border-slate-200/80 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900'
                        }`}
                        onClick={e => {
                          e.stopPropagation();
                          toggleSectionFilter(
                            TravelRequestLineItemSection.PER_DIEM,
                          );
                        }}
                      >
                        <Filter className="size-3.5 text-slate-500" />
                        <span>Filter Columns</span>
                      </button>
                      <ButtonWizard
                        addOnClass="shadow-none px-2 py-1"
                        buttonText=""
                        onBtnClick={e => {
                          e.stopPropagation();
                          setLineItemAccordionConfig(prev => ({
                            ...prev,
                            [TravelRequestLineItemSection.PER_DIEM]:
                              !prev[TravelRequestLineItemSection.PER_DIEM],
                          }));
                        }}
                      >
                        <LineItemAccordionToggleButton
                          isOpen={
                            lineItemAccordionConfig[
                              TravelRequestLineItemSection.PER_DIEM
                            ]
                          }
                        />
                      </ButtonWizard>
                    </div>
                  </div>
                  <AnimatePresence initial={false}>
                    {lineItemAccordionConfig[
                      TravelRequestLineItemSection.PER_DIEM
                    ] && (
                      <LineItemAccordionLineItemContent
                        type={TravelRequestLineItemSection.PER_DIEM}
                      >
                        <LineItemTable
                          table={perDiemTable}
                          showFilters={Boolean(
                            tableFilterState[
                              TravelRequestLineItemSection.PER_DIEM
                            ],
                          )}
                          activeSort={
                            tableSortState[
                              TravelRequestLineItemSection.PER_DIEM
                            ]
                          }
                        />
                      </LineItemAccordionLineItemContent>
                    )}
                  </AnimatePresence>
                </CardWizard>
              )}
              {/* End of per diem section */}

              {/* Start of per km (conveynace) section */}
              {perKmData?.length > 0 && (
                <CardWizard addOnClass="flex flex-col gap-1 p-4 px-0 py-0">
                  <div
                    {...getLineItemAccordionTriggerProps(
                      Boolean(
                        lineItemAccordionConfig[
                          TravelRequestLineItemSection.PER_KM
                        ],
                      ),
                    )}
                    className="flex cursor-pointer items-center justify-between px-3 py-2 transition-colors hover:bg-slate-50/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#8B86F7]"
                    onClick={e => {
                      e.stopPropagation();
                      handleLineItemAccordionClick(
                        TravelRequestLineItemSection.PER_KM,
                      );
                    }}
                  >
                    <LineItemHeaderTitle count={perKmData?.length}>
                      {
                        TRAVEL_REQUEST_LINE_ITEM_SECTION_LABEL_MAP[
                          TravelRequestLineItemSection.PER_KM
                        ]
                      }
                    </LineItemHeaderTitle>
                    <div className="flex items-center gap-2">
                      <Dropdown
                        menu={{
                          items: [
                            { key: 'default', label: 'Default Order' },
                            { type: 'divider' },
                            { key: 'date_desc', label: 'Date (Newest First)' },
                            { key: 'date_asc', label: 'Date (Oldest First)' },
                            {
                              key: 'amount_desc',
                              label: 'Amount (High to Low)',
                            },
                            {
                              key: 'amount_asc',
                              label: 'Amount (Low to High)',
                            },
                          ],
                          onClick: event =>
                            handleLineItemSortMenuClick(event, key =>
                              handleSortChange(
                                TravelRequestLineItemSection.PER_KM,
                                key,
                              ),
                            ),
                          selectedKeys: [
                            tableSortState[TravelRequestLineItemSection.PER_KM]
                              ?.key || 'default',
                          ],
                        }}
                        trigger={['click']}
                      >
                        <button
                          type="button"
                          aria-label="Sort options"
                          className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 text-xs font-semibold shadow-2xs transition-all ${
                            tableSortState[TravelRequestLineItemSection.PER_KM]
                              ? 'border-indigo-300 bg-indigo-50 text-indigo-700 ring-2 ring-indigo-100'
                              : 'border-slate-200/80 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900'
                          }`}
                          onClick={e => e.stopPropagation()}
                        >
                          <ArrowUpDown className="size-3.5 text-slate-500" />
                          <span>Sort</span>
                        </button>
                      </Dropdown>
                      <button
                        type="button"
                        aria-label="Filter Columns"
                        className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 text-xs font-semibold shadow-2xs transition-all ${
                          tableFilterState[TravelRequestLineItemSection.PER_KM]
                            ? 'border-indigo-300 bg-indigo-50 text-indigo-700 ring-2 ring-indigo-100'
                            : 'border-slate-200/80 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900'
                        }`}
                        onClick={e => {
                          e.stopPropagation();
                          toggleSectionFilter(
                            TravelRequestLineItemSection.PER_KM,
                          );
                        }}
                      >
                        <Filter className="size-3.5 text-slate-500" />
                        <span>Filter Columns</span>
                      </button>
                      <ButtonWizard
                        addOnClass="shadow-none px-2 py-1"
                        buttonText=""
                        onBtnClick={e => {
                          e.stopPropagation();
                          setLineItemAccordionConfig(prev => ({
                            ...prev,
                            [TravelRequestLineItemSection.PER_KM]:
                              !prev[TravelRequestLineItemSection.PER_KM],
                          }));
                        }}
                      >
                        <LineItemAccordionToggleButton
                          isOpen={
                            lineItemAccordionConfig[
                              TravelRequestLineItemSection.PER_KM
                            ]
                          }
                        />
                      </ButtonWizard>
                    </div>
                  </div>
                  <AnimatePresence initial={false}>
                    {lineItemAccordionConfig[
                      TravelRequestLineItemSection.PER_KM
                    ] && (
                      <LineItemAccordionLineItemContent
                        type={TravelRequestLineItemSection.PER_KM}
                      >
                        <LineItemTable
                          table={perKmTable}
                          showFilters={Boolean(
                            tableFilterState[
                              TravelRequestLineItemSection.PER_KM
                            ],
                          )}
                          activeSort={
                            tableSortState[TravelRequestLineItemSection.PER_KM]
                          }
                        />
                        {perKmData && perKmData.length > 0 && (
                          <div className="line-item-section-total">
                            <div className="flex items-baseline gap-x-2 text-slate-700">
                              <span className="text-xs font-bold tracking-tight text-slate-600">
                                Total Amount:
                              </span>
                              <span className="text-sm font-extrabold text-[#3C4F76]">
                                {totalPerKmAmount
                                  ? getFormattedAmount(totalPerKmAmount)
                                  : '-'}
                              </span>
                            </div>
                          </div>
                        )}
                      </LineItemAccordionLineItemContent>
                    )}
                  </AnimatePresence>
                </CardWizard>
              )}
              {/* End of per km (conveynace) section */}

              {/* Start of header level attachments section */}
              {attachmentList?.length > 0 && (
                <CardWizard addOnClass="flex flex-col gap-1 p-4 px-0 py-0">
                  <div
                    {...getLineItemAccordionTriggerProps(
                      Boolean(
                        lineItemAccordionConfig[
                          TravelRequestLineItemSection.ATTACHMENTS
                        ],
                      ),
                    )}
                    className="flex cursor-pointer items-center justify-between px-3 py-2 transition-colors hover:bg-slate-50/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#8B86F7]"
                    onClick={e => {
                      e.stopPropagation();
                      handleLineItemAccordionClick(
                        TravelRequestLineItemSection.ATTACHMENTS,
                      );
                    }}
                  >
                    <LineItemHeaderTitle
                      count={
                        attachmentList.filter(item => !item.deleteFlag).length
                      }
                    >
                      {
                        TRAVEL_REQUEST_LINE_ITEM_SECTION_LABEL_MAP[
                          TravelRequestLineItemSection.ATTACHMENTS
                        ]
                      }
                    </LineItemHeaderTitle>
                    <div className="flex gap-2">
                      <ButtonWizard
                        addOnClass="shadow-none px-2 py-1"
                        buttonText=""
                        onBtnClick={e => {
                          e.stopPropagation();
                          setLineItemAccordionConfig(prev => ({
                            ...prev,
                            [TravelRequestLineItemSection.ATTACHMENTS]:
                              !prev[TravelRequestLineItemSection.ATTACHMENTS],
                          }));
                        }}
                      >
                        <LineItemAccordionToggleButton
                          isOpen={
                            lineItemAccordionConfig[
                              TravelRequestLineItemSection.ATTACHMENTS
                            ]
                          }
                        />
                      </ButtonWizard>
                    </div>
                  </div>
                  <AnimatePresence initial={false}>
                    {lineItemAccordionConfig[
                      TravelRequestLineItemSection.ATTACHMENTS
                    ] && (
                      <LineItemAccordionLineItemContent
                        type={TravelRequestLineItemSection.ATTACHMENTS}
                      >
                        <AttachmentTable
                          attachments={attachmentList}
                          travelRequestId={parseInt(id)}
                        />
                      </LineItemAccordionLineItemContent>
                    )}
                  </AnimatePresence>
                </CardWizard>
              )}
              {/* End of header level attachments section */}
            </section>
          </div>
        </main>
      </div>

      <LineItemAttachmentCarousel
        isOpen={attachmentCarousel.isOpen}
        attachments={attachmentCarousel.attachments}
        travelRequestId={Number(id)}
        onClose={() =>
          setAttachmentCarousel({ isOpen: false, attachments: [] })
        }
      />

      {selectedSection === TravelRequestLineItemSection.MODE_OF_JOURNEY &&
        selectedLineItem && (
          <ModeOfJourneyLineItemDetails
            isOpen={attachmentListConfig.isOpen}
            onClose={handleAttachmentListClose}
            lineItemData={selectedLineItem}
            attachments={attachmentListConfig.list}
            travelRequestId={parseInt(id)}
            formConfig={formConfig}
            headerChildren={
              <div className="border-b border-gray-100 flex items-center justify-between pl-0 pr-2 py-0 h-full">
                <div className="flex items-center gap-2.5 h-full">
                  <div className="flex gap-y-0 h-full">
                    <ButtonWizard
                      addOnClass={`p-1 w-max px-2.5 py-0 h-full rounded-none border ${
                        getPreviousLineItemId(selectedLineItem.id, journeyData)
                          ? 'bg-blue-50 border-blue-200 hover:bg-blue-100'
                          : 'bg-gray-100 border-gray-300 cursor-not-allowed'
                      }`}
                      buttonText=""
                      onBtnClick={() => {
                        const prevId = getPreviousLineItemId(
                          selectedLineItem.id,
                          journeyData,
                        );
                        if (prevId) {
                          handleNavigateToLineItem(
                            TravelRequestLineItemSection.MODE_OF_JOURNEY,
                            prevId,
                          );
                        }
                      }}
                      disabled={
                        !getPreviousLineItemId(selectedLineItem.id, journeyData)
                      }
                    >
                      <ChevronLeftIcon
                        className={`size-4 stroke-[2px] ${
                          getPreviousLineItemId(
                            selectedLineItem.id,
                            journeyData,
                          )
                            ? 'text-blue-600'
                            : 'text-gray-400'
                        }`}
                      />
                    </ButtonWizard>

                    <ButtonWizard
                      addOnClass={`p-1 w-max px-2.5 py-0 rounded-none border ${
                        getNextLineItemId(selectedLineItem.id, journeyData)
                          ? 'bg-blue-50 border-blue-200 hover:bg-blue-100'
                          : 'bg-gray-100 border-gray-300 cursor-not-allowed'
                      }`}
                      buttonText=""
                      onBtnClick={() => {
                        const nextId = getNextLineItemId(
                          selectedLineItem.id,
                          journeyData,
                        );
                        if (nextId) {
                          handleNavigateToLineItem(
                            TravelRequestLineItemSection.MODE_OF_JOURNEY,
                            nextId,
                          );
                        }
                      }}
                      disabled={
                        !getNextLineItemId(selectedLineItem.id, journeyData)
                      }
                    >
                      <ChevronRightIcon
                        className={`size-4 stroke-[2px] ${
                          getNextLineItemId(selectedLineItem.id, journeyData)
                            ? 'text-blue-600'
                            : 'text-gray-400'
                        }`}
                      />
                    </ButtonWizard>
                  </div>
                  <h2 className="font-semibold text-text-200 text-base">
                    {'Mode of Journey Details'}
                  </h2>
                </div>
                <div className="flex items-center">
                  <SideSheetHeader onCloseClick={handleAttachmentListClose} />
                </div>
              </div>
            }
          />
        )}

      {selectedSection === TravelRequestLineItemSection.ACCOMMODATION_TYPE &&
        selectedLineItem && (
          <AccommodationLineItemDetails
            isOpen={attachmentListConfig.isOpen}
            onClose={handleAttachmentListClose}
            lineItemData={selectedLineItem}
            attachments={attachmentListConfig.list}
            travelRequestId={parseInt(id)}
            formConfig={formConfig}
            headerChildren={
              <div className="border-b border-gray-100 flex items-center justify-between pl-0 pr-2 py-0 h-full">
                <div className="flex items-center gap-2.5 h-full">
                  <div className="flex gap-y-0 h-full">
                    <ButtonWizard
                      addOnClass={`p-1 w-max px-2.5 py-0 h-full rounded-none border ${
                        getPreviousLineItemId(
                          selectedLineItem.id,
                          accommodationData,
                        )
                          ? 'bg-blue-50 border-blue-200 hover:bg-blue-100'
                          : 'bg-gray-100 border-gray-300 cursor-not-allowed'
                      }`}
                      buttonText=""
                      onBtnClick={() => {
                        const prevId = getPreviousLineItemId(
                          selectedLineItem.id,
                          accommodationData,
                        );
                        if (prevId) {
                          handleNavigateToLineItem(
                            TravelRequestLineItemSection.ACCOMMODATION_TYPE,
                            prevId,
                          );
                        }
                      }}
                      disabled={
                        !getPreviousLineItemId(
                          selectedLineItem.id,
                          accommodationData,
                        )
                      }
                    >
                      <ChevronLeftIcon
                        className={`size-4 stroke-[2px] ${
                          getPreviousLineItemId(
                            selectedLineItem.id,
                            accommodationData,
                          )
                            ? 'text-blue-600'
                            : 'text-gray-400'
                        }`}
                      />
                    </ButtonWizard>

                    <ButtonWizard
                      addOnClass={`p-1 w-max px-2.5 py-0 rounded-none border ${
                        getNextLineItemId(
                          selectedLineItem.id,
                          accommodationData,
                        )
                          ? 'bg-blue-50 border-blue-200 hover:bg-blue-100'
                          : 'bg-gray-100 border-gray-300 cursor-not-allowed'
                      }`}
                      buttonText=""
                      onBtnClick={() => {
                        const nextId = getNextLineItemId(
                          selectedLineItem.id,
                          accommodationData,
                        );
                        if (nextId) {
                          handleNavigateToLineItem(
                            TravelRequestLineItemSection.ACCOMMODATION_TYPE,
                            nextId,
                          );
                        }
                      }}
                      disabled={
                        !getNextLineItemId(
                          selectedLineItem.id,
                          accommodationData,
                        )
                      }
                    >
                      <ChevronRightIcon
                        className={`size-4 stroke-[2px] ${
                          getNextLineItemId(
                            selectedLineItem.id,
                            accommodationData,
                          )
                            ? 'text-blue-600'
                            : 'text-gray-400'
                        }`}
                      />
                    </ButtonWizard>
                  </div>
                  <h2 className="font-semibold text-text-200 text-base">
                    {'Accommodation Details'}
                  </h2>
                </div>
                <div className="flex items-center">
                  <SideSheetHeader onCloseClick={handleAttachmentListClose} />
                </div>
              </div>
            }
          />
        )}

      {(selectedSection === TravelRequestLineItemSection.EXPENSE_CLAIM ||
        selectedSection ===
          TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM) &&
        selectedLineItem && (
          <ExpenseClaimLineItemDetails
            isOpen={attachmentListConfig.isOpen}
            onClose={handleAttachmentListClose}
            lineItemData={selectedLineItem}
            attachments={attachmentListConfig.list}
            travelRequestId={parseInt(id)}
            formConfig={formConfig}
            headerChildren={
              <div className="border-b border-gray-100 flex items-center justify-between pl-0 pr-2 py-0 h-full">
                <div className="flex items-center gap-2.5 h-full">
                  <div className="flex gap-y-0 h-full">
                    <ButtonWizard
                      addOnClass={`p-1 w-max px-2.5 py-0 h-full rounded-none border ${
                        getPreviousLineItemId(
                          selectedLineItem.id,
                          getLineItemsBySection(selectedSection),
                        )
                          ? 'bg-blue-50 border-blue-200 hover:bg-blue-100'
                          : 'bg-gray-100 border-gray-300 cursor-not-allowed'
                      }`}
                      buttonText=""
                      onBtnClick={() => {
                        const prevId = getPreviousLineItemId(
                          selectedLineItem.id,
                          getLineItemsBySection(selectedSection),
                        );
                        if (prevId) {
                          handleNavigateToLineItem(selectedSection, prevId);
                        }
                      }}
                      disabled={
                        !getPreviousLineItemId(
                          selectedLineItem.id,
                          getLineItemsBySection(selectedSection),
                        )
                      }
                    >
                      <ChevronLeftIcon
                        className={`size-4 stroke-[2px] ${
                          getPreviousLineItemId(
                            selectedLineItem.id,
                            getLineItemsBySection(selectedSection),
                          )
                            ? 'text-blue-600'
                            : 'text-gray-400'
                        }`}
                      />
                    </ButtonWizard>

                    <ButtonWizard
                      addOnClass={`p-1 w-max px-2.5 py-0 rounded-none border ${
                        getNextLineItemId(
                          selectedLineItem.id,
                          getLineItemsBySection(selectedSection),
                        )
                          ? 'bg-blue-50 border-blue-200 hover:bg-blue-100'
                          : 'bg-gray-100 border-gray-300 cursor-not-allowed'
                      }`}
                      buttonText=""
                      onBtnClick={() => {
                        const nextId = getNextLineItemId(
                          selectedLineItem.id,
                          getLineItemsBySection(selectedSection),
                        );
                        if (nextId) {
                          handleNavigateToLineItem(selectedSection, nextId);
                        }
                      }}
                      disabled={
                        !getNextLineItemId(
                          selectedLineItem.id,
                          getLineItemsBySection(selectedSection),
                        )
                      }
                    >
                      <ChevronRightIcon
                        className={`size-4 stroke-[2px] ${
                          getNextLineItemId(
                            selectedLineItem.id,
                            getLineItemsBySection(selectedSection),
                          )
                            ? 'text-blue-600'
                            : 'text-gray-400'
                        }`}
                      />
                    </ButtonWizard>
                  </div>
                  <h2 className="font-semibold text-text-200 text-base">
                    {selectedSection ===
                    TravelRequestLineItemSection.EXPENSE_CLAIM
                      ? 'Employee Expense Details'
                      : 'Company Expense Details'}
                  </h2>
                </div>
                <div className="flex items-center gap-2">
                  {selectedSection ===
                    TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM &&
                    selectedLineItem?.isException && (
                      <div className="flex items-center gap-2 bg-blue-50 px-3 py-1.5 rounded-md">
                        <Checkbox checked={true} disabled={true}>
                          <span className="text-xs font-medium text-blue-600">
                            Exception
                          </span>
                        </Checkbox>
                      </div>
                    )}
                  <SideSheetHeader onCloseClick={handleAttachmentListClose} />
                </div>
              </div>
            }
          />
        )}

      {selectedSection === TravelRequestLineItemSection.PER_DIEM &&
        selectedLineItem && (
          <PerDiemLineItemDetails
            isOpen={attachmentListConfig.isOpen}
            onClose={handleAttachmentListClose}
            lineItemData={selectedLineItem}
            attachments={attachmentListConfig.list}
            travelRequestId={parseInt(id)}
            formConfig={formConfig}
            headerChildren={
              <div className="border-b border-gray-100 flex items-center justify-between pl-0 pr-2 py-0 h-full">
                <div className="flex items-center gap-2.5 h-full">
                  <div className="flex gap-y-0 h-full">
                    <ButtonWizard
                      addOnClass={`p-1 w-max px-2.5 py-0 h-full rounded-none border ${
                        getPreviousLineItemId(selectedLineItem.id, perDiemData)
                          ? 'bg-blue-50 border-blue-200 hover:bg-blue-100'
                          : 'bg-gray-100 border-gray-300 cursor-not-allowed'
                      }`}
                      buttonText=""
                      onBtnClick={() => {
                        const prevId = getPreviousLineItemId(
                          selectedLineItem.id,
                          perDiemData,
                        );
                        if (prevId) {
                          handleNavigateToLineItem(
                            TravelRequestLineItemSection.PER_DIEM,
                            prevId,
                          );
                        }
                      }}
                      disabled={
                        !getPreviousLineItemId(selectedLineItem.id, perDiemData)
                      }
                    >
                      <ChevronLeftIcon
                        className={`size-4 stroke-[2px] ${
                          getPreviousLineItemId(
                            selectedLineItem.id,
                            perDiemData,
                          )
                            ? 'text-blue-600'
                            : 'text-gray-400'
                        }`}
                      />
                    </ButtonWizard>

                    <ButtonWizard
                      addOnClass={`p-1 w-max px-2.5 py-0 rounded-none border ${
                        getNextLineItemId(selectedLineItem.id, perDiemData)
                          ? 'bg-blue-50 border-blue-200 hover:bg-blue-100'
                          : 'bg-gray-100 border-gray-300 cursor-not-allowed'
                      }`}
                      buttonText=""
                      onBtnClick={() => {
                        const nextId = getNextLineItemId(
                          selectedLineItem.id,
                          perDiemData,
                        );
                        if (nextId) {
                          handleNavigateToLineItem(
                            TravelRequestLineItemSection.PER_DIEM,
                            nextId,
                          );
                        }
                      }}
                      disabled={
                        !getNextLineItemId(selectedLineItem.id, perDiemData)
                      }
                    >
                      <ChevronRightIcon
                        className={`size-4 stroke-[2px] ${
                          getNextLineItemId(selectedLineItem.id, perDiemData)
                            ? 'text-blue-600'
                            : 'text-gray-400'
                        }`}
                      />
                    </ButtonWizard>
                  </div>
                  <h2 className="font-semibold text-text-200 text-base">
                    {'Per Diem Claim Details'}
                  </h2>
                </div>
                <div className="flex items-center">
                  <SideSheetHeader onCloseClick={handleAttachmentListClose} />
                </div>
              </div>
            }
          />
        )}

      {selectedSection === TravelRequestLineItemSection.PER_KM &&
        selectedLineItem && (
          <PerKmLineItemDetails
            isOpen={attachmentListConfig.isOpen}
            onClose={handleAttachmentListClose}
            lineItemData={selectedLineItem}
            attachments={attachmentListConfig.list}
            travelRequestId={parseInt(id)}
            formConfig={formConfig}
            headerChildren={
              <div className="border-b border-gray-100 flex items-center justify-between pl-0 pr-2 py-0 h-full">
                <div className="flex items-center gap-2.5 h-full">
                  <div className="flex gap-y-0 h-full">
                    <ButtonWizard
                      addOnClass={`p-1 w-max px-2.5 py-0 h-full rounded-none border ${
                        getPreviousLineItemId(selectedLineItem.id, perKmData)
                          ? 'bg-blue-50 border-blue-200 hover:bg-blue-100'
                          : 'bg-gray-100 border-gray-300 cursor-not-allowed'
                      }`}
                      buttonText=""
                      onBtnClick={() => {
                        const prevId = getPreviousLineItemId(
                          selectedLineItem.id,
                          perKmData,
                        );
                        if (prevId) {
                          handleNavigateToLineItem(
                            TravelRequestLineItemSection.PER_KM,
                            prevId,
                          );
                        }
                      }}
                      disabled={
                        !getPreviousLineItemId(selectedLineItem.id, perKmData)
                      }
                    >
                      <ChevronLeftIcon
                        className={`size-4 stroke-[2px] ${
                          getPreviousLineItemId(selectedLineItem.id, perKmData)
                            ? 'text-blue-600'
                            : 'text-gray-400'
                        }`}
                      />
                    </ButtonWizard>

                    <ButtonWizard
                      addOnClass={`p-1 w-max px-2.5 py-0 rounded-none border ${
                        getNextLineItemId(selectedLineItem.id, perKmData)
                          ? 'bg-blue-50 border-blue-200 hover:bg-blue-100'
                          : 'bg-gray-100 border-gray-300 cursor-not-allowed'
                      }`}
                      buttonText=""
                      onBtnClick={() => {
                        const nextId = getNextLineItemId(
                          selectedLineItem.id,
                          perKmData,
                        );
                        if (nextId) {
                          handleNavigateToLineItem(
                            TravelRequestLineItemSection.PER_KM,
                            nextId,
                          );
                        }
                      }}
                      disabled={
                        !getNextLineItemId(selectedLineItem.id, perKmData)
                      }
                    >
                      <ChevronRightIcon
                        className={`size-4 stroke-[2px] ${
                          getNextLineItemId(selectedLineItem.id, perKmData)
                            ? 'text-blue-600'
                            : 'text-gray-400'
                        }`}
                      />
                    </ButtonWizard>
                  </div>
                  <h2 className="font-semibold text-text-200 text-base">
                    {'Conveyance Details'}
                  </h2>
                </div>
                <div className="flex items-center">
                  <SideSheetHeader onCloseClick={handleAttachmentListClose} />
                </div>
              </div>
            }
          />
        )}

      {/* Other attachment side sheets */}
      <AnimatePresence>
        {attachmentListConfig.isOpen && !selectedLineItem && (
          <SideSheet
            isOpen={attachmentListConfig.isOpen}
            addOnClass="w-full max-w-none md:!w-[50vw]"
            onClose={handleAttachmentListClose}
            contentChildren={
              <div className="p-3">
                <AttachmentTable
                  attachments={attachmentListConfig.list}
                  travelRequestId={parseInt(id)}
                />
              </div>
            }
            headerChildren={
              <div className="border-b border-gray-100">
                <SideSheetHeader
                  title={'Attachments'}
                  onCloseClick={handleAttachmentListClose}
                />
              </div>
            }
            footerChildren={<></>}
          />
        )}
      </AnimatePresence>

      {/* Side Sheet for Adding Journey */}
      <AnimatePresence>
        {showJourneySheet && (
          <SideSheet
            isOpen={showJourneySheet}
            addOnClass="w-full max-w-none md:!w-[50vw]"
            onClose={() => setShowJourneySheet(false)}
            contentChildren={<div className="p-4">{''}</div>}
            headerChildren={
              <div className="border-b border-gray-100">
                <SideSheetHeader
                  title={'Mode of Journey Details'}
                  onCloseClick={() => setShowJourneySheet(false)}
                />
              </div>
            }
            footerChildren={<></>}
          />
        )}
      </AnimatePresence>

      {/* SideSheet for Accommodation */}
      <AnimatePresence>
        {isAccommodationSheetOpen && (
          <SideSheet
            isOpen={isAccommodationSheetOpen}
            addOnClass="w-full max-w-none md:!w-[50vw]"
            onClose={() => setIsAccommodationSheetOpen(false)} // Close SideSheet
            contentChildren={<div className="p-4"></div>}
            headerChildren={
              <div className="border-b border-gray-100">
                <SideSheetHeader
                  title={'Accommodation Details'}
                  onCloseClick={() => setIsAccommodationSheetOpen(false)} // Close SideSheet
                />
              </div>
            }
            footerChildren={<></>}
          />
        )}
      </AnimatePresence>

      {/* Side Sheet for Expense Claim */}
      <AnimatePresence>
        {showExpenseClaimSheet && (
          <SideSheet
            isOpen={showExpenseClaimSheet}
            addOnClass="w-full max-w-none md:!w-[50vw]"
            onClose={() => setShowExpenseClaimSheet(false)}
            contentChildren={<div className="p-4"></div>}
            headerChildren={
              <div className="h-12 border-b border-gray-100 flex items-center justify-between pl-3 pr-2">
                <div className="flex items-center gap-2.5 h-full">
                  <h2 className="font-semibold text-text-200 text-base whitespace-nowrap">
                    {'Employee Expense Details'}
                  </h2>
                </div>
                <div className="flex h-full items-center [&>div]:!border-0 [&>div]:!bg-transparent [&>div]:!px-2 [&>div]:!py-0">
                  <SideSheetHeader
                    onCloseClick={() => setShowExpenseClaimSheet(false)}
                  />
                </div>
              </div>
            }
            footerChildren={<></>}
          />
        )}
      </AnimatePresence>

      {/* Side Sheet for Company Expense */}
      <AnimatePresence>
        {showOfficeExpenseClaimSheet && (
          <SideSheet
            isOpen={showOfficeExpenseClaimSheet}
            addOnClass="w-full max-w-none md:!w-[50vw]"
            onClose={() => setShowOfficeExpenseClaimSheet(false)}
            contentChildren={<div className="p-3"></div>}
            headerChildren={
              <div className="h-12 border-b border-gray-100 flex items-center justify-between pl-3 pr-2">
                <div className="flex items-center gap-2.5 h-full">
                  <h2 className="font-semibold text-text-200 text-base whitespace-nowrap">
                    {'Company Expense Details'}
                  </h2>
                </div>
                <div className="flex h-full items-center [&>div]:!border-0 [&>div]:!bg-transparent [&>div]:!px-2 [&>div]:!py-0">
                  <SideSheetHeader
                    onCloseClick={() => setShowOfficeExpenseClaimSheet(false)}
                  />
                </div>
              </div>
            }
            footerChildren={<></>}
          />
        )}
      </AnimatePresence>

      {/* Side Sheet for Per Diem Claim */}
      <AnimatePresence>
        {showPerDiemSheet && (
          <SideSheet
            isOpen={showPerDiemSheet}
            addOnClass="w-full max-w-none md:!w-[50vw]"
            onClose={() => setShowPerDiemSheet(false)}
            contentChildren={<div className="p-4"></div>}
            headerChildren={
              <div className="border-b border-gray-100">
                <SideSheetHeader
                  title={'Per Diem Claim Details'}
                  onCloseClick={() => setShowPerDiemSheet(false)}
                />
              </div>
            }
            footerChildren={<></>}
          />
        )}
      </AnimatePresence>

      {/* Side Sheet for Per Km Claim */}
      <AnimatePresence>
        {showPerKmSheet && (
          <SideSheet
            isOpen={showPerKmSheet}
            addOnClass="w-full max-w-none md:!w-[50vw]"
            onClose={() => setShowPerKmSheet(false)}
            contentChildren={<div className="p-4"></div>}
            headerChildren={
              <div className="border-b border-gray-100">
                <SideSheetHeader
                  title={'Conveyance Details'}
                  onCloseClick={() => setShowPerKmSheet(false)}
                />
              </div>
            }
            footerChildren={<></>}
          />
        )}
      </AnimatePresence>

      {/* Side Sheet for approval change log */}
      <AnimatePresence>
        {isLogOpen && (
          <SideSheet
            isOpen={isLogOpen}
            addOnClass="w-full max-w-none md:!w-[50vw]"
            closeOnClickOutside
            onClose={() => setIsLogOpen(false)}
            contentChildren={
              <div className="p-4 h-full">
                <CommonTable
                  table={logTable}
                  total={totalLog}
                  filters={pagination}
                  setFilters={setPagination}
                  loading={
                    approvalLogData.isLoading || approvalLogData.isFetching
                  }
                  error={approvalLogData.isError}
                  onRetry={() => void approvalLogData.refetch()}
                  emptyTitle="No approval activity"
                  emptyDescription="Approval actions will appear here as the request progresses."
                />
              </div>
            }
            headerChildren={
              <div className="border-b border-gray-100 p-4">
                <div className="flex items-center justify-between">
                  <h2 className="text-lg font-semibold">Approval log</h2>
                  <div className="flex items-center gap-4">
                    <Select
                      value={pagination.sortBy}
                      onChange={val =>
                        setPagination(prev => ({
                          ...prev,
                          sortBy: val,
                          page: 1,
                        }))
                      }
                      style={{ width: 220 }}
                      size="middle"
                      placeholder="Sort by"
                      className="w-64"
                      allowClear
                    >
                      {sortOptions.map(option => (
                        <Option key={option.value} value={option.value}>
                          {option.label}
                        </Option>
                      ))}
                    </Select>
                    <button
                      onClick={() => setIsLogOpen(false)}
                      className="text-gray-500 hover:text-black text-lg"
                    >
                      ✕
                    </button>
                  </div>
                </div>
              </div>
            }
            footerChildren={<></>}
          />
        )}
      </AnimatePresence>

      {/* Side Sheet for SAP log */}
      <AnimatePresence>
        {isSapLogOpen && (
          <SideSheet
            isOpen={isSapLogOpen}
            addOnClass="w-full max-w-none md:!w-[50vw]"
            closeOnClickOutside
            onClose={() => setIsSapLogOpen(false)}
            contentChildren={
              <div className="p-4 h-full">
                <CommonTable
                  table={sapLogTable}
                  total={totalSapLog}
                  filters={sapLogFilters}
                  setFilters={setSapLogFilters}
                  loading={sapLogData.isLoading || sapLogData.isFetching}
                  error={sapLogData.isError}
                  onRetry={() => void sapLogData.refetch()}
                  emptyTitle="No SAP activity"
                  emptyDescription="SAP push attempts and responses will appear here."
                />
              </div>
            }
            headerChildren={
              <div className="border-b border-gray-100 p-4">
                <div className="flex items-center justify-between">
                  <h2 className="text-lg font-semibold">SAP log</h2>
                  <div className="flex items-center gap-4">
                    <Select
                      value={sapLogFilters.sortBy}
                      onChange={val =>
                        setSapLogFilters(prev => ({
                          ...prev,
                          sortBy: val,
                          page: 1,
                        }))
                      }
                      style={{ width: 220 }}
                      size="middle"
                      placeholder="Sort by"
                      className="w-64"
                      allowClear
                    >
                      {sortOptions.map(option => (
                        <Option key={option.value} value={option.value}>
                          {option.label}
                        </Option>
                      ))}
                    </Select>
                    <button
                      onClick={() => setIsSapLogOpen(false)}
                      className="text-gray-500 hover:text-black text-lg"
                    >
                      ✕
                    </button>
                  </div>
                </div>
              </div>
            }
            footerChildren={<></>}
          />
        )}
      </AnimatePresence>

      {/* Side Sheet for change change log */}
      <AnimatePresence>
        {isChangelogOpen && (
          <SideSheet
            isOpen={isChangelogOpen}
            addOnClass="w-full max-w-none md:!w-[50vw]"
            closeOnClickOutside
            onClose={() => setIsChangelogOpen(false)}
            contentChildren={
              <div className="p-4 h-full">
                <CommonTable
                  table={changelogTable}
                  total={totalChangelog}
                  filters={filters}
                  wrapText={false}
                  setFilters={setFilters}
                  loading={changeLogData.isLoading || changeLogData.isFetching}
                  error={changeLogData.isError}
                  onRetry={() => void changeLogData.refetch()}
                  emptyTitle="No changes recorded"
                  emptyDescription="Field-level changes will appear here after the request is updated."
                />
              </div>
            }
            headerChildren={
              <div className="border-b border-gray-100 p-4">
                <div className="flex items-center justify-between">
                  <h2 className="text-lg font-semibold">Change log</h2>
                  <div className="flex items-center gap-4">
                    <Select
                      value={filters.sortBy}
                      onChange={val =>
                        setFilters(prev => ({
                          ...prev,
                          sortBy: val,
                          page: 1,
                        }))
                      }
                      style={{ width: 220 }}
                      size="middle"
                      placeholder="Sort by"
                      className="w-64"
                      allowClear
                    >
                      {sortOptions.map(option => (
                        <Option key={option.value} value={option.value}>
                          {option.label}
                        </Option>
                      ))}
                    </Select>
                    <button
                      onClick={() => setIsChangelogOpen(false)}
                      className="text-gray-500 hover:text-black text-lg"
                    >
                      ✕
                    </button>
                  </div>
                </div>
              </div>
            }
            footerChildren={<></>}
          />
        )}
      </AnimatePresence>

      <div className="h-11"></div>
      {travelReqResponse.data?.data?.isClaimFinalApproved &&
        isAdminTypeRole(user) && (
          <BottomMessageBox>
            {/* Payment Status Toggle */}

            <>
              <div className="flex items-center gap-3 border border-slate-200/90 bg-white px-3 py-1.5 rounded-lg shadow-2xs">
                <span className="text-[11px] font-bold uppercase tracking-wider text-slate-500">
                  Payment Status:
                </span>
                <Switch
                  checked={localPaidStatus}
                  onChange={handleMarkAsPaidToggle}
                  loading={isUpdatingPaidStatus}
                  disabled={isUpdatingPaidStatus}
                  checkedChildren={
                    <div className="flex items-center gap-1">
                      <span>Paid</span>
                    </div>
                  }
                  unCheckedChildren={
                    <div className="flex items-center gap-1">
                      <span>Unpaid</span>
                    </div>
                  }
                  className={
                    localPaidStatus
                      ? 'bg-emerald-600 hover:bg-emerald-700'
                      : 'bg-rose-500 hover:bg-rose-600'
                  }
                />
              </div>
            </>
          </BottomMessageBox>
        )}
    </>
  );

  if (travelReqResponse.isLoading || formFieldMappingResponse.isLoading) {
    content = (
      <div className="p-4 flex flex-col gap-12">
        <div className="flex flex-col gap-6">
          <CardWizard addOnClass="p-8">
            <Skeleton active />
          </CardWizard>
          <CardWizard addOnClass="p-8">
            <Skeleton paragraph={{ rows: 10 }} active />
          </CardWizard>
        </div>
      </div>
    );
  }

  if (travelReqResponse.isError) {
    content = (
      <div className="grid min-h-[60vh] place-items-center p-4">
        <CardWizard addOnClass="w-full max-w-xl p-8 text-center">
          <div className="mx-auto grid size-11 place-items-center rounded-xl bg-rose-50 text-rose-600">
            <Server className="size-5" />
          </div>
          <h2 className="mt-4 text-base font-semibold text-text-100">
            We couldn't load this travel request
          </h2>
          <p className="mx-auto mt-1 max-w-md text-sm text-text-500">
            {extractErrorMessageFromAPI(travelReqResponse.error) ||
              'The request may be unavailable, or your connection was interrupted.'}
          </p>
          <div className="mt-5 flex justify-center gap-2">
            <Button onClick={() => navigate(-1)}>Go back</Button>
            <Button
              type="primary"
              loading={travelReqResponse.isFetching}
              onClick={() => void travelReqResponse.refetch()}
            >
              Try again
            </Button>
          </div>
        </CardWizard>
      </div>
    );
  }

  const [createConfig, resetApprovalHierarchyResponse] =
    useResetApprovalHierarchyMutation();
  const [rearrangeHierarchy, rearrangeApprovalHierarchyResponse] =
    useRearrangeApprovalHierarchyMutation();

  const handleResetClick = async () => {
    try {
      await createConfig({ id }).unwrap();
      setIsResetApprovalHierarchyModalOpen(false);
      setIsApprovalHierarchyOpen(false);
      showNotification(
        'success',
        'Reset',
        'Approval hierarchy reset successfully!',
      );
    } catch (err: any) {
      setIsResetApprovalHierarchyModalOpen(false);
      showNotification(
        'error',
        'Error',
        err?.data?.message || 'Failed to reset approval hierarchy.',
      );
    }
  };

  return (
    <>
      {contextHolder}
      <div className="travel-page-shell flex flex-col gap-0 p-0">{content}</div>
      <div className="h-4"></div>
      {
        <ApprovalConfirmationModal
          config={approvalModalConfig}
          isOpen={isApprovalModalOpen}
          onConfirm={handleApprovalConfirm}
          onCancel={handleApprovalCancel}
          isLoading={updateProcessApprovalActionResponse.isLoading}
          inputForm={approvalForm}
        />
      }

      <Modal
        open={isApprovalHierarchyOpen}
        onCancel={() => setIsApprovalHierarchyOpen(false)}
        footer={null}
        centered
        closable={true}
        title={
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              // backgroundColor: '#f5f5f5',
              padding: '10px 20px',
              borderRadius: '8px',
            }}
          >
            <span className="font-semibold">Approval Hierarchy</span>

            {canManageApprovalHierarchy && (
              <div className="flex gap-2 ml-auto">
                {' '}
                {/* push buttons to the right */}
                <ButtonWizard
                  addOnClass="bg-blue-100 w-auto px-3 py-1.5 border border-blue-300 hover:border-blue-500 group transition rounded text-sm"
                  addOnTextClass="text-blue-700 group-hover:text-blue-900"
                  buttonText="Reset"
                  onBtnClick={() => setIsResetApprovalHierarchyModalOpen(true)}
                >
                  <ReloadOutlined className="text-blue-700 group-hover:text-blue-900 mr-1" />
                </ButtonWizard>
                <ButtonWizard
                  addOnClass="bg-green-100 w-auto px-3 py-1.5 border border-green-300 hover:border-green-500 group transition rounded text-sm"
                  addOnTextClass="text-green-700 group-hover:text-green-900"
                  buttonText="Rearrange"
                  onBtnClick={() => {
                    setIsApprovalHierarchyOpen(false);
                    setOpenApprovalConfigForm(true);
                  }}
                >
                  <SwapOutlined className="text-green-700 group-hover:text-green-900 mr-1" />
                </ButtonWizard>
              </div>
            )}
          </div>
        }
      >
        <ApprovalHierarchy data={travelReqResponse.data?.data} />
      </Modal>

      <ApprovalHierarchySideSheet
        isOpen={openApprovalConfigForm}
        onClose={() => setOpenApprovalConfigForm(false)}
        isSubmitting={rearrangeApprovalHierarchyResponse.isLoading}
        approvalConfigForm={approvalConfigForm}
        employeeDropdown={employeeDropdown}
        claimApprovalHierarchy={
          travelReqResponse?.data?.data?.claimApprovalHierarchy
        }
        onSubmit={async payload => {
          try {
            await rearrangeHierarchy({ id, mappings: payload }).unwrap();
            showNotification(
              'success',
              'Rearrange',
              'Approval hierarchy rearranged successfully!',
            );
            setOpenApprovalConfigForm(false);
          } catch (err: any) {
            showNotification(
              'error',
              'Error',
              err?.data?.message || 'Failed to rearrange approval hierarchy.',
            );
          }
        }}
      />

      <ConfirmationDialog
        title="Are you sure?"
        isOpen={isResetApprovalHierarchyModalOpen}
        onCancel={() => setIsResetApprovalHierarchyModalOpen(false)}
        onConfirm={handleResetClick}
        loading={resetApprovalHierarchyResponse.isLoading}
      >
        <p className="text-text-200 text-xs">
          You are about to reset the approval hierarchy.
        </p>
      </ConfirmationDialog>

      <ConfirmationDialog
        title="Are your sure?"
        isOpen={isCancelRequestModalOpen}
        onCancel={() => {
          setIsCancelRequestModalOpen(false);
          cancellationForm.reset();
        }}
        onConfirm={cancellationForm.handleSubmit(handleCancelRequestConfirm)}
        loading={cancelClaimRequestResponse.isLoading}
      >
        <>
          <TextInput
            name={'remarks'}
            control={cancellationForm.control}
            label={`Reason for cancellation *`}
            rules={{ required: '* This field is required' }}
            formState={cancellationForm.formState}
            config={{
              placeholder: 'Enter here...',
              autoSize: { minRows: 3, maxRows: 3 },
            }}
            variant="textarea"
          />
          <div className="my-2"></div>
          <Tooltip title={cancellationForm.getValues().attachment?.name}>
            <Controller
              name="attachment"
              control={cancellationForm.control}
              rules={{ required: '* This field is required' }}
              render={({ field }) => (
                <Upload
                  className="w-full"
                  accept="image/*,.pdf"
                  fileList={
                    field.value
                      ? [
                          {
                            uid: '-1',
                            name: field.value.name,
                            status: 'done',
                          },
                        ]
                      : []
                  }
                  beforeUpload={file => {
                    field.onChange(file); // store the File object in the form
                    return false; // prevent default upload behavior
                  }}
                  onRemove={() => {
                    field.onChange(null); // clear the field
                  }}
                  itemRender={() => <></>} // hide default preview
                >
                  <ButtonWizard
                    addOnClass="bg-white w-full py-[7px] border border-gray-300 hover:border-primary-500 group transition"
                    addOnTextClass="text-gray-700 group-hover:text-primary-500"
                    buttonText={
                      cancellationForm.getValues().attachment?.name
                        ? `${cancellationForm.getValues().attachment?.name.slice(0, 36)}...`
                        : 'Click to Upload'
                    }
                  >
                    <UploadOutlined className="text-gray-700 group-hover:text-primary-500" />
                  </ButtonWizard>
                </Upload>
              )}
            />
            {cancellationForm.formState.errors.attachment && (
              <p className="text-red-500 text-xs mt-1">
                {cancellationForm.formState.errors.attachment.message?.toString()}
              </p>
            )}
          </Tooltip>
          <p className="text-[11px] mt-2 text-accent-400 font-semibold">
            This request will not be processed for final approval. Create a new
            request if you want to proceed with the tour.
          </p>
        </>
      </ConfirmationDialog>

      <ConfirmationDialog
        onConfirm={handleSendTravelRequestForClaimConfirm}
        onCancel={() => {
          setIsTourSendForClaimModalOpen(false);
          cancellationForm.reset();
        }}
        isOpen={isTourSendForClaimModalOpen}
        title="Send Claim for Approval?"
        loading={sendTravelRequestForClaimResponse.isLoading}
      >
        <p className="text-text-200 text-xs">
          This locks the current claim details and starts the configured Claim
          approval hierarchy. Review expenses and attachments before continuing.
        </p>
      </ConfirmationDialog>

      {/* Side Sheet for Transaction Details */}
      <AnimatePresence>
        {isTransactionDetailsSheetOpen && (
          <SideSheet
            isOpen={isTransactionDetailsSheetOpen}
            addOnClass="w-full max-w-none md:!w-[50vw]"
            closeOnClickOutside
            onClose={() => setIsTransactionDetailsSheetOpen(false)}
            contentChildren={
              <div className="p-6">
                <div className="grid grid-cols-2 gap-x-6 gap-y-4">
                  {/* <GridDataPoint
                    config={{
                      label: 'Claim Category',
                      value: auditData?.claimCategory,
                    }}
                  />
                  <GridDataPoint
                    config={{
                      label: 'Claim Subcategory',
                      value: auditData?.claimSubCategory,
                    }}
                  />
                  <GridDataPoint
                    config={{
                      label: 'Claim Amount',
                      value: auditData?.totalAmount,
                    }}
                  />
                  {(isAdminTypeRole(user) ||
                    travelReqResponse.data?.data?.isClaimFinalApproved) && (
                    <GridDataPoint
                      config={{
                        label: 'Approved Amount',
                        value: auditData?.approvedAmount,
                      }}
                    />
                  )}
                  <GridDataPoint
                    config={{
                      label: 'Submitted On',
                      value: auditData?.submittedOn,
                    }}
                  />
                  {formConfig?.header?.fields?.remarks?.visible ? (
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.remarks?.label,
                        value: header?.remarks,
                      }}
                    />
                  ) : null} */}

                  <GridDataPoint
                    config={{
                      label: 'Claim Month',
                      value: formatClaimMonthYear(
                        auditData?.claimMonth,
                        auditData?.claimYear,
                      ),
                    }}
                  />
                  <GridDataPoint
                    config={{
                      label: 'SAP Document Number',
                      value: auditData?.sapDocumentNumber || '-',
                    }}
                  />
                  <GridDataPoint
                    config={{
                      label: 'UTR No.',
                      value: auditData?.UTRNo || '-',
                    }}
                  />
                  <GridDataPoint
                    config={{
                      label: 'Paid Amount',
                      value: auditData?.paidAmount || '-',
                    }}
                  />
                  <GridDataPoint
                    config={{
                      label: 'SAP Document Date',
                      value: auditData?.sapDocumentDate || '-',
                    }}
                  />
                  <GridDataPoint
                    config={{
                      label: 'Created At',
                      value: auditData?.createdAt,
                    }}
                  />
                  <GridDataPoint
                    config={{
                      label: 'Updated At',
                      value: auditData?.updatedAt,
                    }}
                  />

                  {formConfig?.header?.fields?.cost?.visible ? (
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.cost?.label,
                        value: header?.cost,
                      }}
                    />
                  ) : null}
                  {formConfig?.header?.fields?.advanceAmount?.visible ? (
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.advanceAmount?.label,
                        value: header?.advanceAmount,
                      }}
                    />
                  ) : null}
                  {formConfig?.header?.fields?.handsetModel?.visible ? (
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.handsetModel?.label,
                        value: header?.handsetModel,
                      }}
                    />
                  ) : null}
                  {formConfig?.header?.fields?.dateOfPurchase?.visible ? (
                    <GridDataPoint
                      config={{
                        label:
                          formConfig?.header?.fields?.dateOfPurchase?.label,
                        value: header?.dateOfPurchase,
                      }}
                    />
                  ) : null}
                  {formConfig?.header?.fields?.imeiNo?.visible ? (
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.imeiNo?.label,
                        value: header?.imeiNo,
                      }}
                    />
                  ) : null}
                  {formConfig?.header?.fields?.startDate?.visible ? (
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.startDate?.label,
                        value: header?.startDate,
                      }}
                    />
                  ) : null}
                  {formConfig?.header?.fields?.endDate?.visible ? (
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.endDate?.label,
                        value: header?.endDate,
                      }}
                    />
                  ) : null}
                  {formConfig?.header?.fields?.costCenter?.visible ? (
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.costCenter?.label,
                        value: header?.costCenter,
                      }}
                    />
                  ) : null}
                  {formConfig?.header?.fields?.fromCountry?.visible ? (
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.fromCountry?.label,
                        value: header?.fromCountry,
                      }}
                    />
                  ) : null}
                  {formConfig?.header?.fields?.fromCity?.visible ? (
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.fromCity?.label,
                        value: header?.fromCity,
                      }}
                    />
                  ) : null}
                  {formConfig?.header?.fields?.toCountry?.visible ? (
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.toCountry?.label,
                        value: header?.toCountry,
                      }}
                    />
                  ) : null}
                  {formConfig?.header?.fields?.toCity?.visible ? (
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.toCity?.label,
                        value: header?.toCity,
                      }}
                    />
                  ) : null}
                  {formConfig?.header?.fields?.budget?.visible ? (
                    <GridDataPoint
                      config={{
                        label: formConfig?.header?.fields?.budget?.label,
                        value: header?.budget,
                      }}
                    />
                  ) : null}
                  {travelReqResponse?.data?.data?.approvalStatus ===
                  SystemApprovalStatus.CANCELLED ? (
                    <GridDataPoint
                      config={{
                        label: 'Cancellation Reason',
                        value:
                          travelReqResponse?.data?.data?.cancellationRemarks ||
                          '-',
                      }}
                    />
                  ) : null}
                  {formConfig?.header?.fields?.purposeOfTravel?.visible ? (
                    <GridDataPoint
                      config={{
                        label:
                          formConfig?.header?.fields?.purposeOfTravel?.label,
                        value: header?.purposeOfTravel,
                      }}
                    />
                  ) : null}
                  {formConfig?.header?.fields?.billToCustomer?.visible ? (
                    <GridDataPoint
                      config={{
                        label:
                          formConfig?.header?.fields?.billToCustomer?.label,
                        value: header?.billToCustomer,
                      }}
                    />
                  ) : null}
                </div>
              </div>
            }
            headerChildren={
              <div className="border-b border-gray-100 p-4">
                <div className="flex items-center justify-between">
                  <h2 className="text-lg font-semibold">Transaction Details</h2>
                  <button
                    onClick={() => setIsTransactionDetailsSheetOpen(false)}
                    className="text-gray-500 hover:text-black text-lg"
                  >
                    ✕
                  </button>
                </div>
              </div>
            }
            footerChildren={<></>}
          />
        )}
      </AnimatePresence>

      {(travelReqResponse.data?.data?.requestNo ||
        travelReqResponse.data?.data?.tempRequestNo) &&
        createPortal(
          <Chat
            requestNo={
              travelReqResponse.data?.data?.requestNo ||
              travelReqResponse.data?.data?.tempRequestNo
            }
            header={
              travelReqResponse.data?.data?.requestNo ||
              travelReqResponse.data?.data?.tempRequestNo
            }
            module="claim_management"
          />,
          document.body,
        )}
    </>
  );
};
export default TravelReqDetail;

function GridDataPoint({
  config,
}: {
  config: { label: string; value: string | any };
}) {
  const { label, value } = config;
  return (
    <div className="travel-detail-data-point flex flex-col">
      <div className="font-semibold text-text-200 text-[13px]">{label}</div>
      <div className="font-normal text-text-400 text-[13px]">{value}</div>
    </div>
  );
}

type TravelApprovalUser = {
  ID?: number;
  FullName?: string;
  EmployeeCode?: string;
  EmailID?: string;
};

type TravelApprovalHierarchyItem = {
  id?: number;
  approvalLevel: number;
  approver?: TravelApprovalUser;
};

type TravelApprovalHierarchyData = {
  requestApprovalHierarchySnapshots?: TravelApprovalHierarchyItem[];
  claimApprovalHierarchy?: TravelApprovalHierarchyItem[];
  currentApprovalLevel?: number | null;
  approvalStatus?: string | null;
  isRequestSubmittedForClaimApproval?: boolean;
  isRequestFinalApproved?: boolean;
  isClaimFinalApproved?: boolean;
  requestType?: 'REQUEST' | 'CLAIM' | null;
  forEmployee?: TravelApprovalUser;
  createdByUser?: TravelApprovalUser;
};

const HierarchyPhaseHeader = ({
  eyebrow,
  title,
  status,
}: {
  eyebrow: string;
  title: string;
  status: string;
}) => (
  <div className="flex items-center justify-between gap-3 px-1">
    <div>
      <div className="text-[11px] font-semibold tracking-wide text-slate-400">
        {eyebrow}
      </div>
      <div className="text-sm font-semibold text-slate-800">{title}</div>
    </div>
    <Tag
      color={
        status === 'Approved'
          ? 'success'
          : status === 'Rejected' || status === 'Cancelled'
            ? 'error'
            : status === 'On Hold'
              ? 'warning'
              : 'processing'
      }
    >
      {status}
    </Tag>
  </div>
);

const EmployeeHierarchyStep = ({
  employee,
  label,
}: {
  employee?: TravelApprovalUser;
  label: string;
}) => (
  <div className="rounded-xl border border-blue-200 bg-blue-50/70 p-3">
    <div className="flex items-center gap-3">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-600 text-sm font-semibold text-white">
        {employee?.FullName ? (
          getNameInitials(employee.FullName)
        ) : (
          <User className="h-5 w-5" />
        )}
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[11px] font-semibold tracking-wide text-blue-600">
          {label}
        </div>
        <div className="truncate text-sm font-semibold text-slate-800">
          {employee?.FullName || 'Employee'}
        </div>
        <div className="truncate text-xs text-slate-500">
          {employee?.EmailID || employee?.EmployeeCode || 'Request owner'}
        </div>
      </div>
      <div className="flex items-center gap-1 text-xs font-medium text-blue-700">
        <BadgeCheck className="h-4 w-4" />
        Completed
      </div>
    </div>
  </div>
);

const ApprovalHierarchy = ({ data }: { data: TravelApprovalHierarchyData }) => {
  const requestHierarchy: TravelApprovalHierarchyItem[] =
    data?.requestApprovalHierarchySnapshots || [];
  const activeHierarchy: TravelApprovalHierarchyItem[] =
    data?.claimApprovalHierarchy || [];
  const hasRequestSnapshot = requestHierarchy.length > 0;
  const activeHierarchyIsRequest =
    !hasRequestSnapshot &&
    !data?.isRequestSubmittedForClaimApproval &&
    (data?.requestType === 'REQUEST' || data?.isRequestFinalApproved);
  const employee = data?.forEmployee || data?.createdByUser;
  const activePhaseStatus =
    activeHierarchyIsRequest && data?.isRequestFinalApproved
      ? 'Approved'
      : data?.isClaimFinalApproved
        ? 'Approved'
        : data?.approvalStatus === 'REJECTED'
          ? 'Rejected'
          : data?.approvalStatus === 'CANCELLED'
            ? 'Cancelled'
            : data?.approvalStatus === 'HOLD'
              ? 'On Hold'
              : data?.approvalStatus === 'IN_REVIEW'
                ? 'In Review'
                : 'In Progress';

  return (
    <div className="space-y-3">
      {hasRequestSnapshot && (
        <>
          <HierarchyPhaseHeader
            eyebrow="Phase 1"
            title="Travel Request Approval"
            status="Approved"
          />
          <ApprovalHierarchyList
            data={data}
            approvalMatrix={requestHierarchy}
            phaseFinal
            finalLabel="Travel Request Approved"
          />
          <EmployeeHierarchyStep
            employee={employee}
            label="Expenses Added And Claim Submitted"
          />
        </>
      )}

      {!hasRequestSnapshot && (
        <EmployeeHierarchyStep employee={employee} label="Submitted By" />
      )}

      <HierarchyPhaseHeader
        eyebrow={hasRequestSnapshot ? 'Phase 2' : 'Approval'}
        title={
          activeHierarchyIsRequest
            ? 'Travel Request Approval'
            : 'Claim Approval'
        }
        status={activePhaseStatus}
      />
      <ApprovalHierarchyList
        data={data}
        approvalMatrix={activeHierarchy}
        phaseFinal={
          activeHierarchyIsRequest
            ? Boolean(data?.isRequestFinalApproved)
            : Boolean(data?.isClaimFinalApproved)
        }
        finalLabel={
          activeHierarchyIsRequest
            ? 'Travel Request Approved'
            : 'Claim Approval Complete'
        }
      />
    </div>
  );
};

const ApprovalHierarchyList = ({
  data,
  approvalMatrix,
  phaseFinal,
  finalLabel,
}: {
  data: TravelApprovalHierarchyData;
  approvalMatrix: TravelApprovalHierarchyItem[];
  phaseFinal: boolean;
  finalLabel: string;
}) => {
  const currentApprovalLevel = data?.currentApprovalLevel ?? CREATOR_LEVEL;

  const getStatus = (level: number) => {
    if (phaseFinal) return 'approved';
    if (currentApprovalLevel === CREATOR_LEVEL) return 'pending';
    if (level < currentApprovalLevel) return 'approved';
    if (level === currentApprovalLevel) return 'current';
    return 'upcoming';
  };

  const getStatusDot = (status: string) => {
    switch (status) {
      case 'approved':
        return 'bg-green-500';
      case 'current':
        return 'bg-blue-500';
      default:
        return 'bg-gray-300';
    }
  };

  if (approvalMatrix.length === 0) {
    return (
      <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 px-4 py-5 text-center">
        <Network className="mx-auto mb-2 h-5 w-5 text-slate-400" />
        <div className="text-sm font-medium text-slate-700">
          Approval Hierarchy Not Available
        </div>
        <div className="mt-1 text-xs text-slate-500">
          No approval levels were returned for this phase.
        </div>
      </div>
    );
  }
  return (
    <div className="bg-white rounded-xl border border-slate-300 shadow-sm overflow-hidden">
      <div className="p-4">
        <div className="space-y-2.5">
          {approvalMatrix.map((item, index) => {
            const status = getStatus(item.approvalLevel);
            const isLast = index === approvalMatrix.length - 1;
            return (
              <div key={item.id} className="relative pl-9">
                {/* Vertical line */}
                {!isLast && (
                  <div
                    className={`absolute left-3.5 top-6 bottom-0 w-0.5 ${
                      status === 'approved'
                        ? 'bg-green-300'
                        : status === 'current'
                          ? 'bg-blue-300'
                          : 'bg-gray-200'
                    }`}
                  />
                )}

                {/* Status dot */}
                <div
                  className={`absolute left-2 top-1.5 w-3 h-3 rounded-full z-10 ${getStatusDot(status)} ring-2 ring-white`}
                />

                {/* Content */}
                <div className="mb-2">
                  <div
                    className={`font-medium ${
                      status === 'approved'
                        ? 'text-green-600'
                        : status === 'current'
                          ? 'text-blue-600'
                          : 'text-gray-600'
                    }`}
                  >
                    Level {item.approvalLevel}: {item.approver?.FullName || '-'}
                  </div>
                </div>

                {/* Details card */}
                <div
                  className={`rounded-lg border bg-slate-50 p-3 text-xs ${status === 'approved' ? 'border-green-200' : status === 'current' ? 'border-blue-200' : 'border-gray-100'}`}
                >
                  <div className="flex items-center gap-3 mb-2">
                    {/* Profile Avatar with API */}
                    <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold text-lg overflow-hidden">
                      {item.approver?.FullName ? (
                        <>{getNameInitials(item.approver.FullName)}</>
                      ) : (
                        <User className="w-6 h-6" />
                      )}
                    </div>
                    {/* Employee Code and Email with icons */}
                    <div>
                      <div className="flex items-center gap-2 mb-2 text-gray-700 text-xs font-semibold">
                        <User className="w-4 h-4 text-gray-400" />
                        {item.approver?.EmployeeCode
                          ? `Employee Code: ${item.approver.EmployeeCode}`
                          : 'No employee code'}
                      </div>
                      <div className="flex items-center gap-2 text-gray-700 text-xs">
                        <Mail className="w-4 h-4 text-gray-400" />
                        {item.approver?.EmailID || 'No email'}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {phaseFinal && (
          <div className="mt-6 flex items-center gap-2 text-green-600 bg-green-50 p-3 rounded-lg border border-green-200">
            <BadgeCheck className="w-5 h-5" />
            <span className="font-medium">{finalLabel}</span>
          </div>
        )}
      </div>
    </div>
  );
};
